import React, { Component } from 'react';
import { CompactPicker } from 'react-color';
import ReactHtmlParser from 'react-html-parser';

import { Redirect } from "react-router-dom";
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import { Link } from "react-router-dom";

import Header from './Header';
import Footer from './Footer';
import FileUpload from './FileUpload';
import SettingsUpload from './SettingsUpload';
// import JSONUpload from './JSONUpload';

import binder25red from '../img//binders/red1.png';
import binder35red from '../img//binders/red2.png';
import binder50red from '../img//binders/red3.png';
import binder70red from '../img//binders/red4.png';
import binder25white from '../img//binders/white1.png';
import binder35white from '../img//binders/white2.png';
import binder50white from '../img//binders/white3.png';
import binder70white from '../img//binders/white4.png';
import binder25lightgrey from '../img//binders/lightgrey1.png';
import binder35lightgrey from '../img//binders/lightgrey2.png';
import binder50lightgrey from '../img//binders/lightgrey3.png';
import binder70lightgrey from '../img//binders/lightgrey4.png';
import binder25grey from '../img//binders/grey1.png';
import binder35grey from '../img//binders/grey2.png';
import binder50grey from '../img//binders/grey3.png';
import binder70grey from '../img//binders/grey4.png';
import binder25black from '../img//binders/black1.png';
import binder35black from '../img//binders/black2.png';
import binder50black from '../img//binders/black3.png';
import binder70black from '../img//binders/black4.png';
import binder25beige from '../img//binders/beige1.png';
import binder35beige from '../img//binders/beige2.png';
import binder50beige from '../img//binders/beige3.png';
import binder70beige from '../img//binders/beige4.png';
import binder25yellow from '../img//binders/yellow1.png';
import binder35yellow from '../img//binders/yellow2.png';
import binder50yellow from '../img//binders/yellow3.png';
import binder70yellow from '../img//binders/yellow4.png';
import binder25aqua from '../img//binders/aqua1.png';
import binder35aqua from '../img//binders/aqua2.png';
import binder50aqua from '../img//binders/aqua3.png';
import binder70aqua from '../img//binders/aqua4.png';
import binder25blue from '../img//binders/blue1.png';
import binder35blue from '../img//binders/blue2.png';
import binder50blue from '../img//binders/blue3.png';
import binder70blue from '../img//binders/blue4.png';
import binder25green from '../img//binders/green1.png';
import binder35green from '../img//binders/green2.png';
import binder50green from '../img//binders/green3.png';
import binder70green from '../img//binders/green4.png';

import icoShow from '../img/arrow-down-big.svg';
import icoFont from '../img/ico-font.svg';
import icoDuplicate from '../img/ico-duplicate.svg';
import icoVisibilty from '../img/ico-visibility.svg';
import icoTrash from '../img/ico-trash.svg';
import icoBack from '../img/ico-back.svg';
import icoText from '../img/ico-text.svg';
import icoShape from '../img/ico-shape.svg';
import icoPicktogram from '../img/ico-picktogram.svg';
import icoGraphic from '../img/ico-graphic.svg';
import icoQR from '../img/ico-qr-ean.svg';
import icoFontSize from '../img/ico-fontSize.svg';
import icoColor from '../img/ico-picker.svg';
import icoFontInter from '../img/ico-fontInter.svg';
import icoRotation from '../img/ico-rotation.svg';
import icoVertical from '../img/ico-vertical.svg';
import icoHorizontal from '../img/ico-horizontal.svg';
import icoResize from '../img/ico-resize.svg';
import icoPrintTest from '../img/ico-print-test.svg';
import icoExport from '../img/ico-export.svg';

import pic1 from '../img/picktograms/pic-svg-1.svg';
import pic2 from '../img/picktograms/pic-svg-2.svg';
import pic3 from '../img/picktograms/pic-svg-3.svg';
import pic4 from '../img/picktograms/pic-svg-4.svg';
import pic5 from '../img/picktograms/pic-svg-5.svg';
import pic6 from '../img/picktograms/pic-svg-6.svg';
import pic7 from '../img/picktograms/pic-svg-7.svg';
import pic8 from '../img/picktograms/pic-svg-8.svg';
import pic9 from '../img/picktograms/pic-svg-9.svg';
import pic10 from '../img/picktograms/pic-svg-10.svg';
import pic11 from '../img/picktograms/pic-svg-11.svg';
import pic12 from '../img/picktograms/pic-svg-12.svg';
import pic13 from '../img/picktograms/pic-svg-13.svg';
import pic14 from '../img/picktograms/pic-svg-14.svg';
import pic15 from '../img/picktograms/pic-svg-15.svg';
import pic16 from '../img/picktograms/pic-svg-16.svg';
import pic17 from '../img/picktograms/pic-svg-17.svg';
import pic18 from '../img/picktograms/pic-svg-18.svg';
import pic19 from '../img/picktograms/pic-svg-19.svg';
import pic20 from '../img/picktograms/pic-svg-20.svg';
import pic21 from '../img/picktograms/pic-svg-21.svg';
import pic22 from '../img/picktograms/pic-svg-22.svg';
import pic23 from '../img/picktograms/pic-svg-23.svg';
import pic24 from '../img/picktograms/pic-svg-24.svg';
import pic25 from '../img/picktograms/pic-svg-25.svg';
import pic26 from '../img/picktograms/pic-svg-26.svg';
import pic27 from '../img/picktograms/pic-svg-27.svg';
import pic28 from '../img/picktograms/pic-svg-28.svg';
import pic29 from '../img/picktograms/pic-svg-29.svg';
import pic30 from '../img/picktograms/pic-svg-30.svg';
import pic31 from '../img/picktograms/pic-svg-31.svg';
import pic32 from '../img/picktograms/pic-svg-32.svg';

class Configurator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: '',
      binderSize: '',
      binderColor: '',
      agree: true,
      items: [
      ],
      redirect: false,
      lang: 'en',
      translations: {
      }
    }
  }

  callback = (id) => (imagePath) => {
      const updatedItems = this.state.items.map(item => {
        if (item.id === id) {
          return {
            ...item,
            image: imagePath
          };
        } else {
          return item;
        }
      });

      this.setState({
        items: updatedItems
      });
  }

  componentWillMount() {
    const location = window.location.pathname;
    // console.log(location);
    if(location === "/en/") {
      this.setState({
        lang: 'en',
        translations: {
          infoHead: 'Below you can create dedicated labels for your binder of size',
          info: 'The sticker sheet is inside the binder. If you have already printed a sticker before and your sheet does not contain the complete number of stickers, then fill in below only those labels that are available on the sheet or click the <span>Disable</span> button. If you would like to choose a different binder size, click on the Return to <span>Size Selection<span> button.',
          stickerName: 'Sticker ',
          stickerNameSecond: ' design',
          small: 'Small',
          medium: 'Medium',
          large: 'Large',
          bold: 'Bold',
          normal: 'Normal',
          light: 'Light',
          textOne: 'Text 1',
          textTwo: 'Text 2',
          textOrientation: 'Text orientation',
          elOrientation: 'Element orientation',
          horizontal: 'Horizontal',
          vertical: 'Vertical',
          form: 'Form',
          pictogram: 'Pictogram',
          graphics: 'Graphics',
          codeQrEan: 'QR/EAN code',
          duplicate: 'Copy to the next one',
          enable: 'Enable',
          disable: 'Disable',
          clean: 'Clean',
          selectlabelFields: 'Select label fields you want to edit',
          insertText: 'Insert text',
          typeText: 'Type text here...',
          chooseForm: 'Choose form',
          choosePictogram: 'Choose pictogram',
          chooseGraphic: 'Choose your own graphics from the drive',
          generateQrEan: 'Generate QR / EAN code',
          qrCode: 'QR code',
          eanCode: 'EAN code',
          text: 'Text',
          maxTwo: 'Enter address here, max. 20 characters',
          maxFour: 'Enter address here, max. 40 characters',
          maxSeven: 'Enter address here, max. 50 characters',
          alertHead: 'Remember!',
          alert: '<strong>It is necessary to choose the „actual size” option when printing.</strong> <br><br> In order to properly position the sheet in the printer, carry out the following test: <br>  - Place the sheet in the paper tray. <br> - Press the test print button. <br> - Print the test page. If the sheet, instead of where empty squares should be, has arrows printed, pointing in the same direction as those next to them, the test was successful. <br> - Place the sheet in the same position and begin printing the labels.',
          alertOk: 'GOT IT',
          returnBtn: 'RETURN TO SELECTION MENU',
          highlightInfo: 'Highlight information',
          generatePreview: 'Generate preview and save',
          back: 'Undo',
          continue: 'Continue',
          duplicateAlert: 'This action will overwrite the content of the next label. If there is information already there, press the undo button.',
          prinTest: 'Print Test'
        }
      });
    } else if (location === "/de/") {
      this.setState({
        lang: 'de',
        translations: {
          infoHead: 'Wählen Sie die Größe Ihres Newbinders aus',
          infoHeadSecond: 'Ordner erstellen',
          info: 'Der Aufkleberbogen befindet sich im Inneren des Ordners. Wenn Sie schon einmal einen Aufkleber gedruckt haben und Ihr Aufkleberbogen nicht die komplette Anzahl an Aufklebern enthält, füllen Sie nur die Etiketten aus, die auf dem Aufkleberbogen vorhanden sind oder klicken Sie auf die Schaltfläche <span>Aus</span>. Wenn Sie eine andere Ordnergröße auswählen möchten, klicken Sie auf die Schaltfläche <span>Zurück zur Größenauswahl</span>.',
          stickerName: 'Aufkleber ',
          stickerNameSecond: ' Projekt',
          small: 'Klein',
          medium: 'Mittel',
          large: 'Groß',
          bold: 'Fettes',
          normal: 'Normal',
          light: 'Licht',
          textOne: 'Text 1',
          textTwo: 'Text 2',
          textOrientation: 'Textorientierung',
          elOrientation: 'Elementorientierung',
          horizontal: 'Horizontal',
          vertical: 'Vertikal',
          form: 'Form',
          pictogram: 'Piktogramm',
          graphics: 'Grafik',
          codeQrEan: 'QR/EAN code',
          duplicate: 'Zum nächsten kopieren',
          enable: 'Einschalten',
          disable: 'Aus',
          clean: 'Löschen',
          selectlabelFields: 'Wählen Sie die Aufkleberfelder aus, die Sie bearbeiten möchten',
          insertText: 'Text einfügen',
          typeText: 'Geben Sie hier den Text ein...',
          chooseForm: 'Wählen Sie eine Form aus',
          choosePictogram: 'Wählen Sie ein Piktogramm aus',
          chooseGraphic: 'Wählen Sie Ihre eigene Grafik von der Festplatte aus',
          generateQrEan: 'QR/EAN-Code generieren',
          qrCode: 'QR-code',
          eanCode: 'EAN-code',
          text: 'Text',
          maxTwo: 'Geben Sie hier die Adresse ein, maximal 20 Zeichen',
          maxFour: 'Geben Sie hier die Adresse ein, maximal 40 Zeichen',
          maxSeven: 'Geben Sie hier die Adresse ein, maximal 50 Zeichen',
          alertHead: 'Bitte beachten!',
          alert: '<strong>Achten Sie beim Drucken darauf, die Option tatsächliche Größe/actual size zu markieren.</strong> <br><br> Um das Blatt korrekt in den Drucker einzulegen, führen Sie folgenden Test durch: <br> - Legen Sie das Blatt in das Papierfach ein. <br> - Klicken Sie unten auf die Schaltfläche Testdruck. <br> - Drucken Sie den Test aus. Wenn Pfeile auf den leeren Felder in der gleichen Richtung wie die Pfeile neben ihnen auf Blatt gedruckt werden, war der Test erfolgreich. <br> - Legen Sie ein neues Blatt in die gleiche Position und beginnen Sie mit dem Druck der Etiketten.',
          alertOk: 'VERSTANDEN',
          returnBtn: 'ZURÜCK ZUM AUSWAHLMENÜ',
          highlightInfo: 'Markieren Sie Informationen',
          generatePreview: 'Vorschau erzeugen und speichern',
          back: 'Rückgängig',
          continue: 'Fortsetzen',
          duplicateAlert: 'Diese Aktion überschreibt den Inhalt des nächsten Etiketts. Wenn bereits Informationen vorhanden sind, drücken Sie die Zurück-Taste.',
          prinTest: 'Drucktest'
        }
      });
    } else {
      this.setState({
        lang: 'pl',
        translations: {
          infoHead: 'Poniżej możesz stworzyć dedykowane etykiety na swój segregator o rozmiarze',
          info: 'Arkusz z naklejkami znajduje się we wnętrzu segregatora. Jeżeli już wcześniej drukowałeś naklejkę i Twój arkusz nie zawiera kompletnej ilości naklejek, to poniżej wypełnij tylko te etykiety, które są dostępne na arkuszu lub kliknij przycisk <span>wyłącz</span>. Jeżeli chciałbyś wybrać inny rozmiar segregatora, to kliknij w przycisk <span>wróć do wyboru rozmiaru</span>.',
          stickerName: 'Projekt ',
          stickerNameSecond: ' naklejki',
          small: 'Mały',
          medium: 'Średni',
          large: 'Duży',
          bold: 'Pogrubiony',
          normal: 'Normalny',
          light: 'Cienki',
          textOne: 'Tekst 1',
          textTwo: 'Tekst 2',
          textOrientation: 'Orientacja tekstu',
          elOrientation: 'Orientacja elementu',
          horizontal: 'Poziomo',
          vertical: 'Pionowo',
          form: 'Kształt',
          pictogram: 'Piktogram',
          graphics: 'Grafika',
          codeQrEan: 'Kod QR/EAN',
          duplicate: 'Kopiuj na następną',
          enable: 'Włącz',
          disable: 'Wyłącz',
          clean: 'Wyczyść',
          selectlabelFields: 'Wybierz pola naklejki które chcesz edytować',
          insertText: 'Wstaw tekst',
          typeText: 'Wpisz tekst tutaj...',
          chooseForm: 'Wybierz kształt',
          choosePictogram: 'Wybierz piktogram',
          chooseGraphic: 'Wybierz własną grafikę z dysku',
          generateQrEan: 'Generuj kod QR / EAN',
          qrCode: 'Kod QR',
          eanCode: 'Kod EAN',
          text: 'Tekst',
          maxTwo: 'Wpisz tekst tutaj, maksymalnie 20 znaków',
          maxFour: 'Wpisz tekst tutaj, maksymalnie 40 znaków',
          maxSeven: 'Wpisz tekst tutaj, maksymalnie 50 znaków',
          alertHead: 'Pamiętaj!',
          alert: '<strong>Drukując, koniecznie zaznacz opcję faktyczny rozmiar/actual size.</strong> <br><br> Aby poprawnie umieścić arkusz w drukarce, przeprowadź test: <br> - Umieść arkusz w kasecie na papier. <br> - Kliknij w poniższy przycisk test wydruku. <br> - Wydrukuj test. Jeżeli na arkuszu w miejscu pustych kwadratów zostaną nadrukowane strzałki w tym samym kierunku do tych obok nich, to oznacza powodzenie testu. <br> - Umieść arkusz w tej samej pozycji i rozpocznij nadruk etykiet. <br>',
          alertOk: 'ZROZUMIAŁEM',
          returnBtn: 'WRÓĆ DO WYBORU ROZMIARU',
          highlightInfo: 'Zaznacz informację',
          generatePreview: 'Generuj podgląd i zapisz',
          back: 'Cofnij',
          continue: 'Kontynuuj',
          duplicateAlert: 'To działanie spowoduje nadpisanie zwartości kolejnej etykiety. Jeśli są tam już jakieś informacje, naciśnij przycisk cofnij.',
          prinTest: 'Test Wydruku'
        }
      });
    }
  }

  componentDidMount(stateValueFromChild) {
    const { state } = this.props.location;
    if(state) {
      this.setState({
        binderSize: this.props.location.state.binderSize,
        binderColor: this.props.location.state.binderColor,
      });
      if (state.binderSize === "binder25") {
        let labelsAmount = 12;
        let items = [...this.state.items];
          for(let i=1; i<=labelsAmount; i++){
            items.push({
              id: i,
              name: this.state.translations.stickerName + i + this.state.translations.stickerNameSecond,
              expanded: false,
              active: true,
              textOrientation: "horizontal",
              textOrientationTwo: "horizontal",
              colorPicker: false,
              textOne: true,
              fontSize: 28,
              fontLineHeight: 30,
              transformHorizontal: '50',
              transformVertical: '50',
              fontRotation: 0,
              textTwo: false,
              fontSizeTwo: 22,
              fontLineHeightTwo: 24,
              transformHorizontalTwo: '50',
              transformVerticalTwo: '50',
              fontRotationTwo: 0,
              Shape: false,
              shapeSize: "1",
              shapeColor: '#000',
              transformShapeHorizontal: '50',
              transformShapeVertical: '50',
              shapeRotation: 0,
              shapeSize: 1,
              Picktogram: false,
              transformPicktogramHorizontal: '50',
              transformPicktogramVertical: '50',
              picktogramRotation: 0,
              picktogramSize: 1,
              picktogramColor: "#000",
              Graphic: false,
              transformImageHorizontal: '50',
              transformImageVertical: '50',
              imageRotation: 0,
              imageSize: 100,
              QrEan: false,
              transformQrHorizontal: '50',
              transformQrVertical: '50',
              qrRotation: 0,
              qrSize: 1,
              codeQrEan:'codeQR', qrCodeType: 'regularText', qrSize: "90",
              transformEanVertical: '50',
              transformEanHorizontal: '50',
              eanRotation: 0,
              eanSize: 1
             });
            this.setState({ items });
          }
      } else if (state.binderSize === "binder35") {
        let labelsAmount = 10;
        let items = [...this.state.items];
        for(let i=1; i<=labelsAmount; i++){
          items.push({ id: i, name: this.state.translations.stickerName + i + this.state.translations.stickerNameSecond, expanded: false, active: true, textOrientation: "horizontal", textOrientationTwo: "horizontal", colorPicker: false,
            textOne: true,
            fontSize: 28,
            fontLineHeight: 30,
            transformHorizontal: '50',
            transformVertical: '50',
            fontRotation: 0,
            textTwo: false,
            fontSizeTwo: 22,
            fontLineHeightTwo: 24,
            transformHorizontalTwo: '50',
            transformVerticalTwo: '50',
            fontRotationTwo: 0,
            Shape: false,
            shapeSize: 1,
            shapeColor: '#000',
            transformShapeHorizontal: '50',
            transformShapeVertical: '50',
            shapeRotation: 0,
            shapeSize: 1,
            Picktogram: false,
            transformPicktogramHorizontal: '50',
            transformPicktogramVertical: '50',
            picktogramRotation: 0,
            picktogramSize: 1,
            picktogramColor: "#000",
            Graphic: false,
            transformImageHorizontal: '50',
            transformImageVertical: '50',
            imageRotation: 0,
            imageSize: 100,
            QrEan: false,
            transformQrHorizontal: '50',
            transformQrVertical: '50',
            qrRotation: 0,
            qrSize: 1,
            codeQrEan:'codeQR', qrCodeType: 'regularText', qrSize: "90",
            transformEanVertical: 0,
            transformEanHorizontal: 0,
            eanRotation: 0,
            eanSize: 1
           });
          this.setState({ items });
        }
      } else if (state.binderSize === "binder50") {
        let labelsAmount = 8;
        let items = [...this.state.items];
        for(let i=1; i<=labelsAmount; i++){
          items.push({ id: i, name: this.state.translations.stickerName + i + this.state.translations.stickerNameSecond, expanded: false, active: true, textOrientation: "horizontal", textOrientationTwo: "horizontal", colorPicker: false,
            textOne: true,
            fontSize: 28,
            fontLineHeight: 30,
            transformHorizontal: '50',
            transformVertical: '50',
            fontRotation: 0,
            textTwo: false,
            fontSizeTwo: 22,
            fontLineHeightTwo: 24,
            transformHorizontalTwo: '50',
            transformVerticalTwo: '50',
            fontRotationTwo: 0,
            Shape: false,
            shapeSize: 1,
            shapeColor: '#000',
            transformShapeHorizontal: '50',
            transformShapeVertical: '50',
            shapeRotation: 0,
            shapeSize: 1,
            Picktogram: false,
            transformPicktogramHorizontal: '50',
            transformPicktogramVertical: '50',
            picktogramRotation: 0,
            picktogramSize: 1,
            picktogramColor: "#000",
            Graphic: false,
            transformImageHorizontal: '50',
            transformImageVertical: '50',
            imageRotation: 0,
            imageSize: 100,
            QrEan: false,
            transformQrHorizontal: '50',
            transformQrVertical: '50',
            qrRotation: 0,
            qrSize: 1,
            codeQrEan:'codeQR', qrCodeType: 'regularText', qrSize: "90",
            transformEanVertical: 0,
            transformEanHorizontal: 0,
            eanRotation: 0,
            eanSize: 1
           });
          this.setState({ items });
        }
      } else if (state.binderSize === "binder70") {
        let labelsAmount = 6;
        let items = [...this.state.items];
        for(let i=1; i<=labelsAmount; i++){
          items.push({ id: i, name: this.state.translations.stickerName + i + this.state.translations.stickerNameSecond, expanded: false, active: true, textOrientation: "horizontal", textOrientationTwo: "horizontal", colorPicker: false,
            textOne: true,
            fontSize: 28,
            fontLineHeight: 30,
            transformHorizontal: '50',
            transformVertical: '50',
            fontRotation: 0,
            textTwo: false,
            fontSizeTwo: 22,
            fontLineHeightTwo: 24,
            transformHorizontalTwo: '50',
            transformVerticalTwo: '50',
            fontRotationTwo: 0,
            Shape: false,
            shapeSize: 1,
            shapeColor: '#000',
            transformShapeHorizontal: '50',
            transformShapeVertical: '50',
            shapeRotation: 0,
            shapeSize: 1,
            Picktogram: false,
            transformPicktogramHorizontal: '50',
            transformPicktogramVertical: '50',
            picktogramRotation: 0,
            picktogramSize: 1,
            picktogramColor: "#000",
            Graphic: false,
            transformImageHorizontal: '50',
            transformImageVertical: '50',
            imageRotation: 0,
            imageSize: 100,
            QrEan: false,
            transformQrHorizontal: '50',
            transformQrVertical: '50',
            qrRotation: 0,
            qrSize: 1,
            codeQrEan:'codeQR', qrCodeType: 'regularText', qrSize: "90",
            transformEanVertical: '50',
            transformEanHorizontal: '50',
            eanRotation: 0,
            eanSize: 1
           });
          this.setState({ items });
        }
      }
    } else {
      this.setState({
        redirect: true
      });
    }
  }

  handleChange = ({target: {value, name}}) => this.setState({ [name]: value })

  handleChangeItemColor = (id) => (color) => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          textOneColor: color.hex,
          colorPicker: false
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  handleChangeItemTwoColor = (id) => (color) => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          textTwoColor: color.hex,
          colorPicker: false
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  handleChangeShapeColor = (id) => (color) => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          shapeColor: color.hex,
          colorPicker: false
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  handleChangePicktogramColor = (id) => (color) => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          picktogramColor: color.hex,
          colorPicker: false
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  handleLabelChange = ({target: {id, value, name}}) => {
    const idToNumber = Number(id);
    // const valBreak = value.replace(/\r?\n/g, '<br>');
    const updatedItems = this.state.items.map(item => {
      if (item.id === idToNumber) {
        return {
          ...item,
          [name]: value
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  stepUp = ({target: {id, name}}) => {
    const idToNumber = Number(id);
    const updatedItems = this.state.items.map(item => {
      var integer = parseInt(item[name], 10);
      let increment = integer+1;
      if (item.id === idToNumber) {
        return {
          ...item,
          [name]: increment
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  stepDown = ({target: {id, name}}) => {
    const idToNumber = Number(id);
    const updatedItems = this.state.items.map(item => {
      let decrement = item[name]-1;
      if (item.id === idToNumber) {
        return {
          ...item,
          [name]: decrement
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  blinkDisabled = () => {
    // const el = document.getElementsByClassName("option--disabled");
    // for (let i = 0; i < el.length; i++) {
    //   el[i].classList.add("option--blink");
    //   setTimeout(function(){
    //     el[i].classList.remove("option--blink");
    //   }, 1000);
    // }
  }

  handleToggle = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          expanded: !item.expanded,
          active: true
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleToggleColorPicker = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        if(!item.colorPicker) {
          return {
            ...item,
            colorPicker: true
          };
        } else {
          return {
            ...item,
            colorPicker: false
          };
        }
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleToggleActive = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          active: !item.active,
          expanded: false
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleToggleConfigOptions = ({target: {id, value, title}}) => {
    const idToNumber = Number(id);
    const updatedItems = this.state.items.map(item => {

      if (item.id === idToNumber) {
        if(value) {
          return {
            ...item,
            textOne: false,
            textTwo: false,
            Shape: false,
            Picktogram: false,
            Graphic: false,
            QrEan: false,
            colorPicker: false,
            [value]: true
          };
        } else if (title) {
          return {
            ...item,
            textOne: false,
            textTwo: false,
            Shape: false,
            Picktogram: false,
            Graphic: false,
            QrEan: false,
            colorPicker: false,
            [title]: true
          };
        }
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  handleToggleConfigSVGOptions = (id, value) => {
    const idToNumber = Number(id);
    const updatedItems = this.state.items.map(item => {

      if (item.id === idToNumber) {
        if(value) {
          return {
            ...item,
            textOne: false,
            textTwo: false,
            Shape: false,
            Picktogram: false,
            Graphic: false,
            QrEan: false,
            colorPicker: false,
            [value]: true
          };
        }
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  }

  handleClearLabelOptionTextOne = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          textInputOne: '',
          textOrientation: "horizontal",
          fontWeight: "Normal",
          fontSize: 28,
          fontLineHeight: 30,
          textOneColor: '#000',
          fontRotation: 0,
          transformHorizontal: '50',
          transformVertical: '50'
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionTextTwo = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          textInputTwo: '',
          textOrientationTwo: "horizontal",
          fontWeightTwo: "Normal",
          fontSizeTwo: 22,
          fontLineHeightTwo: 24,
          textTwoColor: '#000',
          fontRotationTwo: 0,
          transformHorizontalTwo: '50',
          transformVerticalTwo: '50'
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionShape = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          binderShape: false,
          shapeSize: '1',
          shapeRotation: '0',
          shapeColor: null,
          transformShapeHorizontal: '50',
          transformShapeVertical: '50',
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionPicktogram = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          binderPicktogram: '',
          picktogramColor: "#000",
          picktogramRotation: '0',
          transformPicktogramHorizontal: '50',
          transformPicktogramVertical: '50',
          picktogramSize: 1
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionImage = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          image: false,
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionQrLink = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          qrLink: "",
          qrCodeType: "link",
          qrSize: "90",
          qrRotation: 0,
          transformQrHorizontal: "50",
          transformQrVertical: "50"
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionQrText = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          qrText: "",
          qrCodeType: "regularText",
          qrSize: "90",
          qrRotation: 0,
          transformQrHorizontal: "50",
          transformQrVertical: "50"
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabelOptionEan = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          eanSize: 1,
          eanText: "",
          eanRotation: 0,
          transformEanHorizontal: '50',
          transformEanVertical: '50',
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleClearLabel = id => {
    const updatedItems = this.state.items.map(item => {
      if (item.id === id) {
        return {
          ...item,
          textInputOne: '',
          textInputTwo: '',
          textOneColor: "#000",
          textTwoColor: "#000",
          fontStyle: "NunitoSans",
          fontStyleTwo: "NunitoSans",
          fontWeight: "Normal",
          fontWeightTwo: "Normal",
          binderShape: "",
          binderPicktogram: '',
          qrText: "",
          eanText: "",
          qrLink: "",
          shapeSize: '1',
          codeQrEan: "codeQR",
          eanRotation: 0,
          eanSize: 1,
          fontLineHeight: 30,
          fontLineHeightTwo: 24,
          fontRotation: 0,
          fontRotationTwo: 0,
          fontSize: 28,
          fontSizeTwo: 22,
          imageRotation: 0,
          image: false,
          imageSize: 100,
          picktogramRotation: 0,
          picktogramSize: 1,
          picktogramColor: "#000",
          qrCodeType: "regularText",
          qrRotation: 0,
          qrSize: "90",
          shapeColor: "#000",
          shapeRotation: 0,
          shapeSize: 1,
          textOrientation: "horizontal",
          textOrientationTwo: "horizontal",
          transformEanHorizontal: '50',
          transformEanVertical: '50',
          transformHorizontal: '50',
          transformHorizontalTwo: '50',
          transformImageHorizontal: '50',
          transformImageVertical: '50',
          transformPicktogramHorizontal: '50',
          transformPicktogramVertical: '50',
          transformQrHorizontal: '50',
          transformQrVertical: '50',
          transformShapeHorizontal: '50',
          transformShapeVertical: '50',
          transformVertical: '50',
          transformVerticalTwo: '50',
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems
    });
  };

  handleDuplicate = (id, nextId) => {
    let currentItem = this.state.items[id];
    let nextItem = this.state.items[nextId];

    let updatedItems = this.state.items.map(item => {

      if (item.id == nextItem.id) {
        return {
          ...currentItem,
          expanded: true,
          id: currentItem.id+1,
          name: this.state.translations.stickerName + (currentItem.id+1) + this.state.translations.stickerNameSecond,
        };
      } else {
        return item;
      }
    });

    this.setState({
      items: updatedItems,
    });
  }

  handleAlert = (id) => {
    const duplicateAlert = document.querySelectorAll(".alert__container");
    const alertAccept = document.querySelectorAll(".alert__accept");
    const alertDecline = document.querySelectorAll(".alert__decline");
    duplicateAlert[id].classList.add('alert__container--active');

    alertAccept[id].addEventListener('click', () => {
      duplicateAlert[id].classList.remove('alert__container--active');
    });

    alertDecline[id].addEventListener('click', () => {
      duplicateAlert[id].classList.remove('alert__container--active');
    });

  }

  handleAgree = () => {
    this.setState({
      agree: false
    });
  }

  handleLocal = () => {
    localStorage.setItem('SiteData',JSON.stringify( this.state ));
  }

  exportFile = () => {
    const currentStateToJSON = JSON.stringify(this.state);
    let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(currentStateToJSON);
    let exportFileDefaultName = 'moxom.json';
    let linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  }

  handleTest = () => {
    window.open('http://newbinder.pl/newbinder-test.pdf', '_blank');
  }

  render() {
    if (this.state.redirect) return <Redirect to="/" />
    return (
      <div className="App">
          <Header/>
          <div className="container__info">
            <p className="p--xl color--blackSecond">{this.state.translations.infoHead}
              {this.state.binderSize === 'binder25' && ' 25' }
              {this.state.binderSize === 'binder35' && ' 35' }
              {this.state.binderSize === 'binder50' && ' 50' }
              {this.state.binderSize === 'binder70' && ' 70' }
              {this.state.translations.infoHeadSecond && ' - '}
              {this.state.translations.infoHeadSecond}
            .</p>
            <p className="color--grayFourth">{ ReactHtmlParser (this.state.translations.info) }</p>
          </div>

          <div className="configurator">
            {this.state.items.map(el => (
              <div
                key={el.id}
                className={el.expanded ? "configurator__tab configurator__tab--opened" : "configurator__tab"}
              >
              <div className={el.active ? "configurator__tabHeader" : "configurator__tabHeader configurator__tabHeader--disabled"}>
                <div className="tab__info">
                  <p className="tab__title color--black" onClick={() => this.handleToggle(el.id)}>{el.name}</p>
                  <div className="d--flex">
                    {el.id < this.state.items.length
                      ?
                      <button className="tabHeader__button button__duplicate" onClick={() => this.handleAlert(el.id-1)}><img src={icoDuplicate} alt={this.state.translations.duplicate}/>{this.state.translations.duplicate}</button>
                      :
                      null
                    }
                    <button
                      className="tabHeader__button"
                      onClick={() => this.handleToggleActive(el.id)}
                      >
                      <img src={icoVisibilty} alt="Enable/Disable"/>
                      {el.active? this.state.translations.disable : this.state.translations.enable}
                    </button>
                    <button className="tabHeader__button" onClick={() => this.handleClearLabel(el.id)}><img src={icoTrash} alt={this.state.translations.clean}/>{this.state.translations.clean}</button>
                    <button
                      className={el.expanded? "tab__add tab__add--opened" : "tab__add"}
                      onClick={() => this.handleToggle(el.id)}
                      >
                      <img src={icoShow} alt={!el.expanded? "Otwórz" : "Zamknij"}/>
                    </button>
                  </div>
                </div>
              </div>
              <div className="alert__container">
                <div className="container__info container__info--red duplicate__alert">
                  <p className="p--xl color--blackSecond">{this.state.translations.alertHead}</p>
                  <p className="color--grayFourth">{this.state.translations.duplicateAlert}</p>
                  <div className="d--flexBetween buttons">
                    <button className="alert__decline btn--secondary">{this.state.translations.back}</button>
                    <button className="alert__accept btn--primary" onClick={() => this.handleDuplicate(el.id - 1, el.id)}>{this.state.translations.continue}</button>
                  </div>
                </div>
              </div>
              {el.expanded &&
                <div className="tab__content">
                  <div className="configurator__options">
                    <button id={el.id} value="textOne" className={el.textOne ? "option--active" : "option--disabled"} onClick={this.handleToggleConfigOptions}>
                      <img src={icoText} alt={this.state.translations.textOne}/>
                      {this.state.translations.textOne}
                    </button>
                    <button id={el.id} value="textTwo" className={el.textTwo ? "option--active" : "option--disabled"} onClick={this.handleToggleConfigOptions}>
                      <img src={icoText} alt={this.state.translations.textTwo}/>
                      {this.state.translations.textTwo}
                    </button>
                    <button id={el.id} value="Shape" className={el.Shape ? "option--active" : "option--disabled"} onClick={this.handleToggleConfigOptions}>
                      <img src={icoShape} alt={this.state.translations.form}/>
                      {this.state.translations.form}
                    </button>
                    <button id={el.id} value="Picktogram" className={el.Picktogram ? "option--active" : "option--disabled"} onClick={this.handleToggleConfigOptions}>
                      <img src={icoPicktogram} alt={this.state.translations.pictogram}/>
                      {this.state.translations.pictogram}
                    </button>
                    <button id={el.id} value="Graphic" className={el.Graphic ? "option--active" : "option--disabled"} onClick={this.handleToggleConfigOptions}>
                      <img src={icoGraphic} alt={this.state.translations.graphics}/>
                      {this.state.translations.graphics}
                    </button>
                    <button id={el.id} value="QrEan" className={el.QrEan ? "option--active" : "option--disabled"} onClick={this.handleToggleConfigOptions}>
                      <img src={icoQR} alt={this.state.translations.codeQrEan}/>
                      {this.state.translations.codeQrEan}
                    </button>
                  </div>
                  <div className="preview">
                    <p>{this.state.translations.selectlabelFields}:</p>
                    <div className="position--relative overflow--hidden">

                      {this.state.binderSize === 'binder25' &&
                        <div className="preview--image">
                          {(() => {
                            switch (this.state.binderColor) {
                              default: return <img src={binder25red} alt="Podgląd"/>;
                              case "#eaeaea": return <img src={binder25white} alt="Podgląd"/>;
                              case "#afafaf": return <img src={binder25lightgrey} alt="Podgląd"/>;
                              case "#7c7c7c": return <img src={binder25grey} alt="Podgląd"/>;
                              case "#222222": return <img src={binder25black} alt="Podgląd"/>;
                              case "#f4f0e1": return <img src={binder25beige} alt="Podgląd"/>;
                              case "#ffda34": return <img src={binder25yellow} alt="Podgląd"/>;
                              case "#9ee6d9": return <img src={binder25aqua} alt="Podgląd"/>;
                              case "#678ca3": return <img src={binder25blue} alt="Podgląd"/>;
                              case "#57746f": return <img src={binder25green} alt="Podgląd"/>;
                            }
                          })()}
                        </div>
                      }
                      {this.state.binderSize === 'binder35' &&
                        <div className="preview--image">
                          {(() => {
                            switch (this.state.binderColor) {
                              default: return <img src={binder35red} alt="Podgląd"/>;
                                case "#eaeaea": return <img src={binder35white} alt="Podgląd"/>;
                                case "#afafaf": return <img src={binder35lightgrey} alt="Podgląd"/>;
                                case "#7c7c7c": return <img src={binder35grey} alt="Podgląd"/>;
                                case "#222222": return <img src={binder35black} alt="Podgląd"/>;
                                case "#f4f0e1": return <img src={binder35beige} alt="Podgląd"/>;
                                case "#ffda34": return <img src={binder35yellow} alt="Podgląd"/>;
                                case "#9ee6d9": return <img src={binder35aqua} alt="Podgląd"/>;
                                case "#678ca3": return <img src={binder35blue} alt="Podgląd"/>;
                                case "#57746f": return <img src={binder35green} alt="Podgląd"/>;
                            }
                          })()}
                        </div>
                      }
                      {this.state.binderSize === 'binder50' &&
                        <div className="preview--image">
                          {(() => {
                            switch (this.state.binderColor) {
                              default: return <img src={binder50red} alt="Podgląd"/>;
                                case "#eaeaea": return <img src={binder50white} alt="Podgląd"/>;
                                case "#afafaf": return <img src={binder50lightgrey} alt="Podgląd"/>;
                                case "#7c7c7c": return <img src={binder50grey} alt="Podgląd"/>;
                                case "#222222": return <img src={binder50black} alt="Podgląd"/>;
                                case "#f4f0e1": return <img src={binder50beige} alt="Podgląd"/>;
                                case "#ffda34": return <img src={binder50yellow} alt="Podgląd"/>;
                                case "#9ee6d9": return <img src={binder50aqua} alt="Podgląd"/>;
                                case "#678ca3": return <img src={binder50blue} alt="Podgląd"/>;
                                case "#57746f": return <img src={binder50green} alt="Podgląd"/>;
                            }
                          })()}
                        </div>
                      }
                      {this.state.binderSize === 'binder70' &&
                        <div className="preview--image">
                          {(() => {
                            switch (this.state.binderColor) {
                              default: return <img src={binder70red} alt="Podgląd"/>;
                                case "#eaeaea": return <img src={binder70white} alt="Podgląd"/>;
                                case "#afafaf": return <img src={binder70lightgrey} alt="Podgląd"/>;
                                case "#7c7c7c": return <img src={binder70grey} alt="Podgląd"/>;
                                case "#222222": return <img src={binder70black} alt="Podgląd"/>;
                                case "#f4f0e1": return <img src={binder70beige} alt="Podgląd"/>;
                                case "#ffda34": return <img src={binder70yellow} alt="Podgląd"/>;
                                case "#9ee6d9": return <img src={binder70aqua} alt="Podgląd"/>;
                                case "#678ca3": return <img src={binder70blue} alt="Podgląd"/>;
                                case "#57746f": return <img src={binder70green} alt="Podgląd"/>;
                            }
                          })()}
                        </div>
                      }

                        <div className={
                            this.state.binderSize === "binder25" ? "preview--position preview--position25 position--absolute overflow--hidden" :
                            this.state.binderSize === "binder35" ? "preview--position preview--position35 position--absolute overflow--hidden" :
                            this.state.binderSize === "binder50" ? "preview--position preview--position50 position--absolute overflow--hidden" :
                            this.state.binderSize === "binder70" ? "preview--position preview--position70 position--absolute overflow--hidden" :
                            null
                          }
                          onClick={this.blinkDisabled}
                          >
                          <div className={
                              this.state.binderSize === "binder25" ? "preview--box preview--box25" :
                              this.state.binderSize === "binder35" ? "preview--box preview--box35" :
                              this.state.binderSize === "binder50" ? "preview--box preview--box50" :
                              this.state.binderSize === "binder70" ? "preview--box preview--box70" :
                              null
                            }>
                          {/* TEXT ONE */}
                          {el.textOne &&
                            <div className="grid--vertical">
                              {el.transformVertical === '50' &&
                                <hr className="vertical--line"/>
                              }
                            </div>
                          }
                          {el.textOne &&
                            <div className="grid--horizontal">
                              {el.transformHorizontal === '50' &&
                                <hr className="horizontal--line"/>
                              }
                            </div>
                          }
                          {el.textInputOne &&
                            <div className=
                              {(() => {
                                switch (el.fontStyle) {
                                  default: return "textTwo font--nunitoSans position--absolute";
                                  case "OpenSans": return "textTwo font--openSans position--absolute";
                                  case "Roboto": return "textTwo font--roboto position--absolute";
                                  case "RobotoSlab": return "textTwo font--robotoSlab position--absolute";
                                  case "Lato": return "textTwo font--lato position--absolute";
                                  case "Raleway": return "textTwo font--raleway position--absolute";
                                  case "Playfair": return "textTwo font--playfair position--absolute";
                                  case "PlayfairItalic": return "textTwo font--playfairItalic position--absolute";
                                  case "Merriweather": return "textTwo font--merriweather position--absolute";
                                  case "Baloo": return "textTwo font--baloo position--absolute";
                                }
                              })()}
                              style={{left: el.transformHorizontal + '%', top: el.transformVertical + "%",
                                transform: "translate(" + -el.transformHorizontal + "%," + -el.transformVertical + "%)"
                               }}
                              >
                              <span className={el.textOrientation} style={{fontSize: el.fontSize + "px", lineHeight: el.fontLineHeight + "px", fontWeight: el.fontWeight, color: el.textOneColor}}>
                                <span
                                  id={el.id}
                                  title="textOne"
                                  className='text--container position--absolute' style={{transform: 'translate(' + -el.transformHorizontal + '%,' + -el.transformVertical + '%) rotate('+ el.fontRotation +'deg)'}}
                                  onClick={this.handleToggleConfigOptions}
                                  >
                                  { ReactHtmlParser (el.textInputOne.replace(/\r?\n/g, '<br>')) }
                                </span>
                              </span>
                            </div>
                          }
                          {/* TEXT TWO */}
                          {el.textTwo &&
                            <div className="grid--vertical">
                              {el.transformVerticalTwo === '50' &&
                                <hr className="vertical--line"/>
                              }
                            </div>
                          }
                          {el.textTwo &&
                            <div className="grid--horizontal">
                              {el.transformHorizontalTwo === '50' &&
                                <hr className="horizontal--line"/>
                              }
                            </div>
                          }
                          {el.textInputTwo &&
                            <div className=
                              {(() => {
                                switch (el.fontStyleTwo) {
                                  default: return "textTwo font--nunitoSans position--absolute";
                                  case "OpenSans": return "textTwo font--openSans position--absolute";
                                  case "Roboto": return "textTwo font--roboto position--absolute";
                                  case "RobotoSlab": return "textTwo font--robotoSlab position--absolute";
                                  case "Lato": return "textTwo font--lato position--absolute";
                                  case "Raleway": return "textTwo font--raleway position--absolute";
                                  case "Playfair": return "textTwo font--playfair position--absolute";
                                  case "PlayfairItalic": return "textTwo font--playfairItalic position--absolute";
                                  case "Merriweather": return "textTwo font--merriweather position--absolute";
                                  case "Baloo": return "textTwo font--baloo position--absolute";
                                }
                              })()}
                              style={{left: el.transformHorizontalTwo + '%', top: el.transformVerticalTwo + "%",
                                transform: "translate(" + -el.transformHorizontalTwo + "%," + -el.transformVerticalTwo + "%)"
                               }}
                              >
                              <span className={el.textOrientationTwo} style={{fontSize: el.fontSizeTwo + "px", lineHeight: el.fontLineHeightTwo + "px", fontWeight: el.fontWeightTwo, color: el.textTwoColor}}>
                                <span
                                  id={el.id}
                                  title="textTwo"
                                  className='text--container position--absolute' style={{transform: 'translate(' + -el.transformHorizontalTwo + '%,' + -el.transformVerticalTwo + '%) rotate('+ el.fontRotationTwo +'deg)'}}
                                  onClick={this.handleToggleConfigOptions}
                                  >
                                  { ReactHtmlParser (el.textInputTwo.replace(/\r?\n/g, '<br>')) }
                                </span>
                              </span>
                          </div>
                          }
                          {/* SHAPE */}
                          {el.Shape &&
                            <div className="grid--vertical">
                              {el.transformShapeVertical === '50' &&
                                <hr className="vertical--line"/>
                              }
                            </div>
                          }
                          {el.Shape &&
                            <div className="grid--horizontal">
                              {el.transformShapeHorizontal === '50' &&
                                <hr className="horizontal--line"/>
                              }
                            </div>
                          }
                          {el.binderShape &&
                          <div
                            className=
                            {(() => {
                              switch (el.binderShape) {
                                default: return "elShape position--absolute d--inlineFlex";
                                case "shapeSquare": return "elShape shape--shapeSquare position--absolute d--inlineFlex";
                                case "shapeRectangle": return "elShape shape--shapeRectangle position--absolute d--inlineFlex";
                                case "shapeCircle": return "elShape shape--shapeCircle position--absolute d--inlineFlex";
                              }
                            })()}
                            style={{left:  el.transformShapeHorizontal + '%', top: el.transformShapeVertical + '%',
                              transform: "translate(" + -el.transformShapeHorizontal + "%," + -el.transformShapeVertical + "%) rotate(" + el.shapeRotation + "deg)"
                            }}
                            >
                            {el.binderShape === "shapeSquare" &&
                              <div
                                id={el.id}
                                title="Shape"
                                className={(el.shapeSize === '.5' && 'half') || (el.shapeSize === '.25' && 'quarter')} style={{backgroundColor: el.shapeColor}}
                                onClick={this.handleToggleConfigOptions}
                                >
                              </div>
                            }
                            {el.binderShape === "shapeRectangle" &&
                              <div
                                id={el.id}
                                title="Shape"
                                className={(el.shapeSize === '.5' && 'half') || (el.shapeSize === '.25' && 'quarter')} style={{backgroundColor: el.shapeColor}}
                                onClick={this.handleToggleConfigOptions}
                                >
                              </div>
                            }
                            {el.binderShape === "shapeCircle"  &&
                              <div
                                id={el.id}
                                title="Shape"
                                className={(el.shapeSize === '.5' && 'half') || (el.shapeSize === '.25' && 'quarter')} style={{backgroundColor: el.shapeColor}}
                                onClick={this.handleToggleConfigOptions}
                                >
                              </div>
                            }
                            {el.binderShape === "shapeTriangle"  &&
                              <svg
                                onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Shape')}
                                width={(el.shapeSize === 1 && '90') || (el.shapeSize === '.5' && '80') ||( el.shapeSize === '.25' && '70') || (el.shapeSize && '90') }
                                height={(el.shapeSize === 1 && '90') || (el.shapeSize === '.5' && '80') || (el.shapeSize === '.25' && '70') || (el.shapeSize && '90') }
                                viewBox="0 0 57 49" fill="none" xmlns="http://www.w3.org/2000/svg"
                                >
                                <path d="M28.5 0.213074L56.6458 48.9631H0.354174L28.5 0.213074Z" fill={el.shapeColor ? el.shapeColor : "#000"}/>
                              </svg>
                            }
                            {el.binderShape === "shapePentagon"  &&
                              <svg
                                onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Shape')}
                                width={(el.shapeSize === 1 && '80') || (el.shapeSize === '.5' && '70') || (el.shapeSize === '.25' && '60') || (el.shapeSize && '80')}
                                height={(el.shapeSize === 1 && '80') || (el.shapeSize === '.5' && '70') || (el.shapeSize === '.25' && '60') || (el.shapeSize && '80')}
                                viewBox="0 0 52 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 0.213074L51.6785 18.8696L41.8702 49.0565H10.1298L0.321474 18.8696L26 0.213074Z" fill={el.shapeColor ? el.shapeColor : "#000"}/>
                              </svg>
                            }
                            {el.binderShape === "shapeHexagon"  &&
                              <svg
                                onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Shape')}
                                width={(el.shapeSize === 1 && '80') || (el.shapeSize === '.5' && '70') || (el.shapeSize === '.25' && '60') || (el.shapeSize && '80')}
                                height={(el.shapeSize === 1 && '80') || (el.shapeSize === '.5' && '70') || (el.shapeSize === '.25' && '60') || (el.shapeSize && '80')}
                                viewBox="0 0 48 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24 0.213074L47.3827 13.7131V40.7131L24 54.2131L0.617313 40.7131V13.7131L24 0.213074Z" fill={el.shapeColor ? el.shapeColor : "#000"}/>
                              </svg>
                            }
                            {el.binderShape === "shapeOctagon"  &&
                              <svg
                                onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Shape')}
                                width={(el.shapeSize === 1 && '80') || (el.shapeSize === '.5' && '70') || (el.shapeSize === '.25' && '60') || (el.shapeSize && '80')}
                                height={(el.shapeSize === 1 && '80') || (el.shapeSize === '.5' && '70') || (el.shapeSize === '.25' && '60') || (el.shapeSize && '80')}
                                viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.7765 0.223509L35.4412 0.313678L49.9896 14.9896L49.8994 35.6543L35.2235 50.2027L14.5588 50.1125L0.0103777 35.4366L0.100546 14.7719L14.7765 0.223509Z" fill={el.shapeColor ? el.shapeColor : "#000"}/>
                              </svg>
                            }
                          </div>
                          }
                          {/* PICKTOGRAM */}
                          {el.Picktogram &&
                            <div className="grid--vertical">
                              {el.transformPicktogramVertical === '50' &&
                                <hr className="vertical--line"/>
                              }
                            </div>
                          }
                          {el.Picktogram &&
                            <div className="grid--horizontal">
                              {el.transformPicktogramHorizontal === '50' &&
                                <hr className="horizontal--line"/>
                              }
                            </div>
                          }
                          {el.binderPicktogram &&
                          <div className="elPictogram d--inlineFlex position--absolute" style={{left:  el.transformPicktogramHorizontal + '%', top: el.transformPicktogramVertical + '%',
                            transform: "translate(" + -el.transformPicktogramHorizontal + "%," + -el.transformPicktogramVertical + "%)"
                          }}>
                            {el.binderPicktogram === "pic1"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-1</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="330.09" y1="297.55" x2="280.5" y2="297.55"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M237.07,133.74c-9.09,31.51-33.81,54.46-57.3,55.61-23.56-1.15-48.36-24.24-57.37-55.91l-4.45.7a9.27,9.27,0,0,1-10.55-7.72l-4.35-28a9.27,9.27,0,0,1,7.71-10.55l3.16-.49a45.39,45.39,0,0,1-2.17-13.91V63.15a46,46,0,0,1,45.87-45.87h5.47a5.77,5.77,0,0,1,.33-2.46c2.82-7.44,21.63-7.2,42,.52a103.66,103.66,0,0,1,12.06,5.45,46.05,46.05,0,0,1,28.31,42.36V73.46a45.39,45.39,0,0,1-2.17,13.91l3.16.49a9.27,9.27,0,0,1,7.71,10.55l-4.35,28a9.28,9.28,0,0,1-10.56,7.72l-2.53-.4Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M17.87,350.37,9.63,275.49v-7.86c0-17.5,17.72-27.6,32.49-30.59,13.5-2.74,64-13.69,80.34-25l1-.16L153,350.61l17.75-91.52-15-38.76h48.54l-15,38.76,17.25,91.52,30.06-138.73,1,.16c16.34,11.31,66.84,22.26,80.33,25,14.77,3,32.49,13.11,32.49,30.59v7.86l-8.24,74.88"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic2"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-2</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M331.5,190.73V317.54a11.36,11.36,0,0,1-11.27,11.26H39.77A11.33,11.33,0,0,1,28.5,317.54V192.6"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M129.12,81.92V49.64A18.5,18.5,0,0,1,147.56,31.2h64.88a18.61,18.61,0,0,1,18.44,18.44V81.92"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M149,215.88c-47.24-2.35-94.61-12-136.95-32.52l.19-89.57A11.28,11.28,0,0,1,23.45,82.53h313.1a11.3,11.3,0,0,1,11.26,11.26L348,181c-42.61,22.46-91.05,32.4-138.85,34.84"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M159.77,199.75h40.46a6.26,6.26,0,0,1,6.25,6.24v27.76a6.26,6.26,0,0,1-6.25,6.24H159.77a6.26,6.26,0,0,1-6.25-6.24V206a6.26,6.26,0,0,1,6.25-6.24Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic3"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-3</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M267.18,302.39a150.93,150.93,0,1,1-106.43-258V193.85h0v1.48L267.18,302.39Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M350.11,191l0,1.48a150.47,150.47,0,0,1-44.55,107.06L199.2,192.46V191Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M187.76,13.74A150.93,150.93,0,0,1,338.67,163.19h-151V13.74Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="150.54" y1="44.75" x2="10.22" y2="185.07"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="160.75" y1="88.49" x2="14.95" y2="234.28"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="160.75" y1="142.43" x2="30.93" y2="272.25"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="161.3" y1="195.83" x2="54.58" y2="302.55"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="188.18" y1="222.89" x2="85.13" y2="325.94"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="215.07" y1="249.95" x2="123.42" y2="341.59"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="241.95" y1="277.01" x2="173.21" y2="345.75"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic4"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-4</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M97,167.43a16.86,16.86,0,1,0,16.86,16.86A16.86,16.86,0,0,0,97,167.43Zm55.21-56.07a16.86,16.86,0,1,0,16.86,16.86,16.86,16.86,0,0,0-16.86-16.86Zm55.22,50.15a16.86,16.86,0,1,0,16.85,16.86,16.86,16.86,0,0,0-16.85-16.86ZM112.07,169l26.05-25.71m29.3-1.27,26.3,24.07m41-69.34,40.16-8.16-55.53,77.87m55.53-77.87,5,39.21m-246.08-92H326.21V244H33.79V35.82Zm-24.15-1H350.36M180,244v90.75m0-299.9V9.41m.66,281.52,94.19,59.66m-95.51-59.66L85.15,350.59"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic5"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-5</title>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="341.82 310.51 310.56 341.77 230.29 261.5 262.06 230.74 341.82 310.51 341.82 310.51"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M151.18,18.23a133,133,0,1,1-133,133,133,133,0,0,1,133-133Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M149.83,44.37a107.9,107.9,0,0,1,107.91,107.9"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="147.68" y1="93.86" x2="147.68" y2="114.95"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="147.68" y1="206.95" x2="147.68" y2="228.04"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M178.25,126c-9.71-3.23-18.47-6.27-27.27-7.26-47.39-5.32-53.46,42.41-3,42.26,49-.15,44.4,47.63-3.1,42.25-8.79-1-17.56-4-27.21-7.25"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic6"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-6</title>
                                  <line class="cls-1" x1="11" y1="351" x2="349" y2="351"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="39.79 351 39.79 9 245.93 9 245.93 351"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="250.51 66.06 320.21 66.06 320.21 341.13"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="123.86 346.72 123.86 315.64 161.86 315.64 161.86 346.72"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="45.66" x2="215.08" y2="45.66"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="281.8" y1="126.67" x2="281.8" y2="108.99"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="281.8" y1="186.3" x2="281.8" y2="168.61"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="281.8" y1="245.92" x2="281.8" y2="228.24"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="281.8" y1="305.55" x2="281.8" y2="287.86"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="80.26" x2="215.08" y2="80.26"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="114.86" x2="215.08" y2="114.86"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="149.45" x2="215.08" y2="149.45"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="184.05" x2="215.08" y2="184.05"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="218.65" x2="215.08" y2="218.65"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="253.25" x2="215.08" y2="253.25"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="70.63" y1="287.84" x2="215.08" y2="287.84"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="69.74" y1="322.94" x2="96.43" y2="322.94"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="188.39" y1="322.94" x2="215.08" y2="322.94"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic7"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-7</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="183.05" y1="9.31" x2="183.05" y2="39.23"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="291.66" y1="50.68" x2="270.5" y2="71.84"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="341" y1="167.22" x2="311.08" y2="167.22"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="287.34" y1="278.9" x2="266.18" y2="257.74"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="72.66" y1="50.68" x2="93.82" y2="71.84"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="19" y1="161.11" x2="48.92" y2="161.11"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="68.34" y1="278.9" x2="89.5" y2="257.74"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="144.3 182.8 176.79 227.53 225.72 141.18"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M136.09,281C132.16,220.53,85.36,251.13,80,169c-3.4-51.82,44.78-94,100-94s103.69,42.23,100,94c-5,70.05-39.73,55.9-52.47,92.53"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="134.94" y1="335.06" x2="225.07" y2="319.61"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="134.94" y1="308.92" x2="225.07" y2="293.48"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="134.94" y1="282.79" x2="225.07" y2="267.35"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M210.11,329.21c-1.49,13.28-17,22.83-34.73,21.32-11.15-.95-20.49-6.07-25.49-13"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic8"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-8</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="21.3" y1="315.96" x2="338.7" y2="315.96"/>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="38.54 225.7 80.97 225.7 80.97 315.35 38.54 315.35 38.54 225.7 38.54 225.7"/>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="118.7 145.64 161.13 145.64 161.13 315.35 118.7 315.35 118.7 145.64 118.7 145.64"/>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="198.87 217.12 241.3 217.12 241.3 315.35 198.87 315.35 198.87 217.12 198.87 217.12"/>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="279.03 179.95 321.46 179.95 321.46 315.35 279.03 315.35 279.03 179.95 279.03 179.95"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M59.75,125.45a24.47,24.47,0,1,0,24.48,24.47,24.47,24.47,0,0,0-24.48-24.47Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M139.92,44a24.47,24.47,0,1,0,24.47,24.47A24.48,24.48,0,0,0,139.92,44Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M220.08,116.85a24.47,24.47,0,1,0,24.48,24.47,24.47,24.47,0,0,0-24.48-24.47Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M300.25,79.82a24.48,24.48,0,1,0,24.47,24.48,24.48,24.48,0,0,0-24.47-24.48Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="81.65" y1="127.68" x2="119.48" y2="90.36"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="162.01" y1="88.51" x2="200.19" y2="123.46"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="244.18" y1="130.89" x2="272.95" y2="116.9"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic9"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-9</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M160.65,265.78,152,298.88c-1.55,6-11.45,4.62-15.91.34L63.91,230c-4.47-4.27-6.34-14.4-.34-15.91l32-10.69M131,233.64l-.7-.67L86.44,191c32.82-45.94,69.75-107.5,107.7-147.1,33.26-34.71,87-40.82,137-20.46l.48.19c23.11,50,18.44,103.94-14.4,138.21-37.95,39.6-97.89,79.12-142.39,113.86l-43.84-42ZM241,16.15C268.8,8.41,300.65,11,331.13,23.4l.48.19c14,30.38,17.82,62.19,11.28,90.17L241,16.15ZM253.6,105a27.2,27.2,0,1,1-38.45.82A27.2,27.2,0,0,1,253.6,105Zm-51.27,53.5a27.2,27.2,0,1,1-38.45.82,27.2,27.2,0,0,1,38.45-.82ZM86.8,190.8l61-88.79c-19.68-3.78-40.25-12.66-59-11.34C29.44,94.84,19.29,146.6,14,195.75l72.8-4.95ZM175,275.29l86.12-64.67c4.62,19.5,14.36,39.67,13.84,58.5-1.65,59.4-52.93,71.74-101.81,79.11L175,275.29ZM102.15,167.48,198,258.36"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic10"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-10</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeWidth="15px" stroke-miterlimit="22.93" d="M180,41.3A138.7,138.7,0,1,1,41.3,180,138.7,138.7,0,0,1,180,41.3Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="15px" d="M180,12V68.88M12,180H68.88M180,348V291.12M348,180H291.12m-42.89-13.6a69.57,69.57,0,1,1-68.23-56,69.2,69.2,0,0,1,37,10.67m-80.77,45.64,40.56,45.64,89.83-102.07"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic11"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-11</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M145,179h70.1c32.7,0,65.32-27.3,59.45-59.46L260.55,43.1c-3.42-18.75-15.63-34.69-34.68-34.69H134.13c-19,0-31.26,15.92-34.68,34.69l-14,76.44C79.63,151.71,112.25,179,145,179Zm-39.61,22.47H254.66a14.43,14.43,0,0,1,14.39,14.39v8.85a14.42,14.42,0,0,1-14.39,14.38H105.34A14.43,14.43,0,0,1,91,224.71v-8.85a14.44,14.44,0,0,1,14.39-14.39ZM96.52,324.33A13.63,13.63,0,1,1,82.89,338a13.63,13.63,0,0,1,13.63-13.63Zm83.48,0A13.63,13.63,0,1,1,166.37,338,13.63,13.63,0,0,1,180,324.33Zm83.48,0A13.63,13.63,0,1,1,249.85,338a13.63,13.63,0,0,1,13.63-13.63ZM180,239.09v82.57m-77.58-3.28a61.32,61.32,0,0,1,18-17.73,94.8,94.8,0,0,1,26.76-12,124.82,124.82,0,0,1,65.55,0,94.74,94.74,0,0,1,26.77,12,61.32,61.32,0,0,1,18,17.73m-241.92-175,21.69-.63c43-1.36-4.12,97.31,44.72,96.4.92,0,16.21-.07,17.22-.17m245-95.6-21.69-.63c-43-1.36,4.12,97.31-44.72,96.4-.92,0-16.21-.07-17.22-.17M180,186.87v14.6"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic12"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-12</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="92c.74,8.65-1.17,20.11-9.35,29.38a30.72,30.72,0,0,1-2.82,2.76l37.33,86.1,40.3-85.09a29,29,0,0,1-4.19-3.8c-7.19-8-8.7-20.49-8-29.47"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M306.73,351.56c14.13-74.07-1.78-103.82-86-126.38"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M143.07,224.17l-32.92,12.12C50.79,258.47,38.84,282,55.66,351.56"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="266.91" y1="326.72" x2="221.88" y2="326.72"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M160.49,75.87c15.17,0,51.36-2.65,61.69-18,11.49,11.87,20.64,47.9,20.64,66.79,0,35.89-25.43,74.25-57.47,74.25s-58-29.09-58-65,1.11-58.09,33.15-58.09Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M279,242.93c20.31-23.63,5.81-48.82,5.81-86.44C284.8,85,283,3.83,183.24,8.64S80.72,66.57,80.72,138c0,44.9.77,79.05,15.38,98.23"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic13"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-13</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="246.45" y1="183.38" x2="246.45" y2="204.47"/><line class="cls-1" x1="246.45" y1="296.47" x2="246.45" y2="317.56"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M246.45,153.33a97.14,97.14,0,1,1-97.14,97.14,97.14,97.14,0,0,1,97.14-97.14Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M277,215.47c-9.72-3.23-18.48-6.27-27.27-7.25-47.39-5.33-53.46,42.41-3,42.25,49-.15,44.41,47.63-3.09,42.26-8.79-1-17.56-4.05-27.21-7.26"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="74.36 50.58 36.43 50.58 36.43 12.39 234.09 12.39 234.09 50.58"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="73.6 88.76 73.6 50.58 271.26 50.58 271.26 88.76 214.94 88.76"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="16.41 126.95 16.41 88.76 214.08 88.76 214.08 126.95"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="16.41 165.13 16.41 126.95 214.08 126.95 214.08 154.81"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="16.41 203.32 16.41 165.13 198.29 165.13"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="16.41 241.5 16.41 203.32 160.57 203.32"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="16.41 279.69 16.41 241.5 147.84 241.5"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="174.37 317.88 16.41 317.88 16.41 279.69 152.74 279.69"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic14"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-14</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M259.46,256.25c36.21-21.34,74.85-22.32,79.3-44.76,6.57-33.1-29-39.34-50.45-29.74"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M120.37,111.36c-12.32-11.06-10.83-28.76-3.46-38.8s9.4-25.5-2.5-37.77m50,71c-16.94-12.92-14.89-33.61-4.76-45.34s12.94-29.8-3.44-44.14m54.11,95C198,100.3,199.44,82.6,206.81,72.56s9.41-25.5-2.5-37.77"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M87.31,343.66H236.74c26.05,0,65.28-31.62,66.88-42.16H20.44c1.6,10.54,39,42.16,66.87,42.16Zm22.53-44C61.42,272.86,30,192.53,33.69,151.78H290.37c4.12,45.19-33.82,124.44-76.15,147.85"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic15"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-15</title>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="11.52 207.87 348.48 207.87 348.48 32.15 11.52 32.15 11.52 207.87 11.52 207.87"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,177.2c23.69,0,42.89-25.61,42.89-57.19S203.69,62.82,180,62.82,137.11,88.42,137.11,120,156.31,177.2,180,177.2Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M72.89,200.13A52.89,52.89,0,0,0,20,147.24"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M287.11,200.13A52.89,52.89,0,0,1,340,147.24"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M72.89,39.89A52.89,52.89,0,0,1,20,92.78"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M287.11,39.89A52.89,52.89,0,0,0,340,92.78"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M94.11,131.1A11.09,11.09,0,1,0,83,120,11.09,11.09,0,0,0,94.11,131.1Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M265.73,131.1A11.09,11.09,0,1,0,254.64,120a11.1,11.1,0,0,0,11.09,11.09Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="12.73" y1="248.81" x2="347.27" y2="248.81"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="12.73" y1="288.33" x2="347.27" y2="288.33"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="12.73" y1="327.85" x2="347.27" y2="327.85"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic16"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-16</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="43.58" y1="111.75" x2="159.08" y2="69.63"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="199.57" y1="54.86" x2="316.42" y2="12.24"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="347.76" x2="180" y2="84.21"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="97.47" y1="347.76" x2="262.53" y2="347.76"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,43.39A20.41,20.41,0,1,1,159.59,63.8,20.41,20.41,0,0,1,180,43.39Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="17.74" y1="264.36" x2="136.52" y2="264.36"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M20.75,276.31C32,298,52.62,313.17,77.13,313.17c24.26,0,44.61-14.89,56-36.14,4.35-8.14,4.32-13.1,1.22-22.62L85.7,127.5A7.23,7.23,0,0,0,71.88,127l0,0c-17.35,50.16-34.72,78.12-52.06,128.28-3,8.61-3,13.57.91,21Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="223.49" y1="190.49" x2="342.26" y2="190.49"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M226.5,202.44c11.26,21.66,31.86,36.86,56.38,36.86,24.25,0,44.61-14.89,56-36.14,4.35-8.14,4.32-13.1,1.21-22.62L291.45,53.64a7.23,7.23,0,0,0-13.83-.54l0,0c-17.36,50.16-34.73,78.13-52.07,128.28-3,8.62-3,13.58.92,21Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic17"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-17</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M97.07,188.07a45.17,45.17,0,0,1-12.33-24A39.55,39.55,0,0,1,69.81,167c-19.28,0-35.15-13.62-37.13-31.1-11.44-5.94-19.18-17.33-19.18-30.4,0-19.22,16.72-34.8,37.35-34.8.51,0,1,0,1.52,0a25.25,25.25,0,0,1-2.64-11.23c0-14.82,12.89-26.82,28.79-26.82a30.55,30.55,0,0,1,10.71,1.92c8.42-13.32,24-22.25,41.74-22.25a50.64,50.64,0,0,1,27.67,8.09,29.78,29.78,0,0,1,42.47,1,47.67,47.67,0,0,1,18.72-3.79,46.6,46.6,0,0,1,31.62,12.1,30.85,30.85,0,0,1,8.45-1.17c15.44,0,28,11.32,28.75,25.54a30.83,30.83,0,0,1,4.74-.37c15.68,0,28.39,11.85,28.39,26.45a25,25,0,0,1-.37,4.26c14.6,4.72,25.09,17.66,25.09,32.87a33,33,0,0,1-6.61,19.77,41.3,41.3,0,0,1,2.49,14.13c0,24.29-21.14,44-47.21,44-.6,0-1.2,0-1.79,0,.11,1,0,2,.17,3,1.78,13.65-8.22,25.61-19.76,25.61-10.7,0-12.74-6.74-21-2.94-25.5,11.71-42.79,7.08-64.46-11.23m150-71.78A31.92,31.92,0,0,1,317.86,145c-17,0-30.74-12.82-30.74-28.64m3.43-13.41c0,14.4-12.53,26.07-28,26.07a29.26,29.26,0,0,1-15.74-4.51m75.71,62.33a32.3,32.3,0,0,1-21.22,4.69c-16.84-2-28.71-16.42-26.51-32.11M95.13,119.26a28.53,28.53,0,0,1,5.44,20.86c-2.21,16.58-18.44,28.35-36.23,26.28m76.12-74.11a27.5,27.5,0,0,1-8,18.91c-11.42,11.71-30.86,12.57-43.42,1.93m107-48.54a21,21,0,0,1,9.78,11.5c3.71,10.89-2.75,22.52-14.44,26m50.52-38.25a23.31,23.31,0,0,0-15.24-3.69c-12.19,1.23-21,11.44-19.67,22.79m-20.49,18.53a26.28,26.28,0,0,1,4.33,19.39c-2.6,15.23-18,25.61-34.29,23.19m112.94,16.42a34.35,34.35,0,0,1-20.92,10.81,35.08,35.08,0,0,1-30.14-10.34M288.53,217a26,26,0,0,1-16.61,5.87c-13.82,0-25-10.45-25-23.33M35.61,144.74c-6.9-9.44-4.29-22.31,5.84-28.74m143.33,55.42a33.42,33.42,0,0,1-21.4,13.47c-19.36,3.39-38.37-10.58-42.45-31.2m64.81,18.63L139,241.51l46,.2L105.28,342.93c-5,6.3-20.63,7.32-17.16-.34l34.25-75.47-36.83.55,41.84-95.21"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic18"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-18</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="12" y1="291.18" x2="176.93" y2="291.18"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="23.17 289.16 23.17 145.88 78.65 145.88 78.65 289.16"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="111.31 289.16 111.31 83.74 166.79 83.74 166.79 289.16"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="199.46 192.33 199.46 16.04 254.94 16.04 254.94 165.31"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M260.48,168.93A87.52,87.52,0,1,0,348,256.45a87.52,87.52,0,0,0-87.52-87.52Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M293.62,218.26c-6.72,2.77-62.53,63.86-72.07,72.93"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="293.62 280.33 293.62 218.26 231.55 218.26"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic19"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-19</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M63.23,12H296.77A10.6,10.6,0,0,1,307.3,22.54V337.46A10.63,10.63,0,0,1,296.77,348H63.23A10.6,10.6,0,0,1,52.7,337.46V22.54A10.57,10.57,0,0,1,63.23,12Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="116.2" y1="127.7" x2="116.2" y2="185.66"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="87.23" y1="156.67" x2="145.19" y2="156.67"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="261.77" y1="136.32" x2="220.78" y2="177.3"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="95.71" y1="264.24" x2="136.7" y2="305.22"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="95.71" y1="305.22" x2="136.7" y2="264.24"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="53.98" y1="218.97" x2="306.03" y2="218.97"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="92.95" x2="180" y2="344.99"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="214.61" y1="269.14" x2="272.57" y2="269.14"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="214.61" y1="300.32" x2="272.57" y2="300.32"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="53.98" y1="92.39" x2="306.02" y2="92.39"/>
                                  <path fill-rule="evenodd" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M214.75,130.06a7,7,0,1,0,9.84,0,7,7,0,0,0-9.84,0Z"/>
                                  <path fill-rule="evenodd" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M258.06,173.37a7,7,0,1,0,9.84,0,7,7,0,0,0-9.84,0Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic20"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-20</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="177.32" y1="148.87" x2="177.32" y2="169.16"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="177.32" y1="257.67" x2="177.32" y2="277.96"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M206.74,179.74c-9.35-3.1-17.78-6-26.24-7-45.59-5.12-51.44,40.81-2.91,40.66,47.16-.15,42.72,45.82-3,40.65-8.46-1-16.89-3.89-26.18-7"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M177.33,78.84A134.58,134.58,0,1,1,42.75,213.42,134.58,134.58,0,0,1,177.33,78.84Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="161.63" y1="78.84" x2="161.63" y2="48.35"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="193.02" y1="48.35" x2="193.02" y2="78.84"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="263.72 107.33 297.56 73.49 317.25 93.18 283.41 127.02"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M142.15,12h70.36a6.1,6.1,0,0,1,6.08,6.08V38.79a6.11,6.11,0,0,1-6.08,6.09H142.15a6.1,6.1,0,0,1-6.08-6.09V18.08A6.1,6.1,0,0,1,142.15,12Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M177.33,106.4a107,107,0,1,1-107,107,107,107,0,0,1,107-107Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic21"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-21</title>
                                  <polygon fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="32.76 34.8 327.24 34.8 327.24 244.48 32.76 244.48 32.76 34.8 32.76 34.8"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="8.44" y1="33.85" x2="351.56" y2="33.85"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="244.48" x2="180" y2="335.86"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="33.85" x2="180" y2="8.21"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180.67" y1="291.71" x2="275.51" y2="351.79"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="179.33" y1="291.71" x2="84.49" y2="351.79"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="158.73" y1="91.39" x2="267.43" y2="91.39"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="92.57 84.85 106.3 102.79 122.06 82.22"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="158.73" y1="137.23" x2="267.43" y2="137.23"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="92.57 130.7 106.3 148.64 122.06 128.06"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="158.73" y1="183.08" x2="267.43" y2="183.08"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="92.57 176.55 106.3 194.49 122.06 173.91"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic22"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-22</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M168.29,66.06A84.22,84.22,0,0,1,99,135.31"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M171.24,209.4a84.22,84.22,0,0,1,68.7-68.7"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M168.5,207.4,100.08,139a17.62,17.62,0,0,0-24.84,0L57.29,156.92a17.62,17.62,0,0,0,0,24.85l68.41,68.41a17.6,17.6,0,0,0,24.84,0l17.95-17.94a17.62,17.62,0,0,0,0-24.84Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M282.91,93,214.49,24.57a17.6,17.6,0,0,0-24.84,0L171.71,42.51a17.6,17.6,0,0,0,0,24.84l68.42,68.42a17.62,17.62,0,0,0,24.84,0l17.94-18a17.59,17.59,0,0,0,0-24.83Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M187.67,183.08l124,130.17c17.42,18.29,51.58-17.6,33.28-35L215.59,155.16"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="29.48" y1="305.41" x2="199.78" y2="305.41"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="9.87" y1="340.56" x2="224.63" y2="340.56"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic23"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-23</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M320.94,95.6H296.26c-1.1,0-2,1.51-2,3.36v41.73c0,1.85.89,3.36,2,3.36h24.68c1.09,0,2-1.51,2-3.36V99c0-1.85-.89-3.36-2-3.36Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M320.94,216H296.26c-1.1,0-2,1.51-2,3.36V261c0,1.85.89,3.36,2,3.36h24.68c1.09,0,2-1.51,2-3.36V219.31c0-1.85-.89-3.36-2-3.36Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M309.19,90.71v-22a18,18,0,0,0-17.9-17.9H68.71a18,18,0,0,0-17.9,17.9V291.29a18,18,0,0,0,17.9,17.9H291.29a18,18,0,0,0,17.9-17.9V266.37"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="309.19 213.63 309.19 180 309.19 149.26"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,105.94A74.06,74.06,0,1,0,254.06,180,74.06,74.06,0,0,0,180,105.94Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,140.77A39.23,39.23,0,1,0,219.23,180,39.24,39.24,0,0,0,180,140.77Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M303.05,14.16H57A42.91,42.91,0,0,0,14.16,57V303A42.91,42.91,0,0,0,57,345.84h246.1A42.91,42.91,0,0,0,345.84,303V57a42.91,42.91,0,0,0-42.79-42.79Z"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="105.94" x2="180" y2="123.68"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="127.63" y1="127.63" x2="140.18" y2="140.17"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="105.94" y1="180" x2="123.68" y2="180"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="127.63" y1="232.37" x2="140.18" y2="219.82"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="254.06" x2="180" y2="236.32"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="232.37" y1="232.37" x2="219.83" y2="219.82"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="254.06" y1="180" x2="236.32" y2="180"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="232.37" y1="127.63" x2="219.83" y2="140.17"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic24"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-24</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M78.31,18.58H281.69V175.43c0,49.58-45.82,90.25-101.68,90.25h0c-55.86,0-101.69-40.61-101.69-90.25V18.58ZM180,265.8v70.85m-92.84,4.77H272.84M75.94,43.89H12c13.85,37.42,36.23,61.73,63.94,75.77M284.06,43.89H348c-13.85,37.42-36.23,61.73-63.94,75.77M180,59.05,199,104l47,3-36.86,31.92,11.65,45.67L179.05,159.4l-39.84,25.19,11.06-47.48L114,107l48.57-4.15L180,59.05Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic25"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-25</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M125.9,171.08l22.71-12.17-10.15-24a57.74,57.74,0,0,0,9.11-11.12l25.5,5.24,7.46-24.67L156.4,94.63A56.88,56.88,0,0,0,155,80.32L176.71,66,164.55,43.28l-24,10.15a57.8,57.8,0,0,0-11.13-9.11l5.25-25.5L110,11.36l-9.77,24.13A57.39,57.39,0,0,0,86,36.91L71.63,15.18,48.91,27.35l10.16,24A56.89,56.89,0,0,0,50,62.44L24.46,57.2,17,81.86l24.12,9.77A57.51,57.51,0,0,0,42.54,106L20.81,120.26,33,143l24-10.16a57.48,57.48,0,0,0,11.13,9.12l-5.24,25.49,24.67,7.46,9.76-24.12a57.47,57.47,0,0,0,14.32-1.43l14.32,21.74Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M105.24,71.72c-13.13-4-23.92,1.81-27.89,14.93s1.81,23.92,14.93,27.89,23.92-1.81,27.89-14.94-1.81-23.91-14.93-27.88Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M271.75,343.66l29.63-15.87-13.25-31.26A74.65,74.65,0,0,0,300,282l33.25,6.84L343,256.69,311.53,244a74.39,74.39,0,0,0-1.86-18.66L338,206.61,322.16,177l-31.27,13.25a74.29,74.29,0,0,0-14.51-11.89l6.84-33.25-32.17-9.74-12.73,31.47a74.59,74.59,0,0,0-18.68,1.86L201,140.33,171.34,156.2l13.24,31.25A75,75,0,0,0,172.69,202l-33.24-6.84-9.73,32.17L161.18,240A74.59,74.59,0,0,0,163,258.72l-28.34,18.66L150.56,307l31.25-13.24a75.06,75.06,0,0,0,14.52,11.9l-6.84,33.24,32.18,9.73,12.73-31.47a74.47,74.47,0,0,0,18.67-1.86l18.68,28.35Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M247.83,204.07a39.62,39.62,0,1,0,26.45,49.4,39.62,39.62,0,0,0-26.45-49.4Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic26"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-26</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,340.13C94.73,303.22,37.16,233.19,37.16,152.86c0-41.16.49-82.41.49-123.62,12.78,15.05,38.52,25.33,68.2,25.33,35.5,0,65.36-14.71,74.15-34.7,8.79,20,38.66,34.7,74.15,34.7,29.68,0,55.42-10.28,68.2-25.33,0,41.21.49,82.46.49,123.62,0,80.33-57.57,150.36-142.84,187.27Z"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="113.24 175.69 168.55 239.76 246.76 120.24"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic27"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-27</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M267.2,123.32a141.69,141.69,0,1,1-31.14-31.13m3.15,59.12a102.75,102.75,0,1,1-31.14-31.14m2.54,59.74a63.84,63.84,0,1,1-31.14-31.13m-3,65.27a24.9,24.9,0,1,1-31.14-31.14m9.2,22.53,177-177M271.45,95.62l35.81,11.26L349,65.13,313.2,53.88M265,89.16l-11.26-35.8,41.74-41.74,11.26,35.8"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic28"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-28</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M190.34,247.38l44.4-23.62c10.44-5.56,30.84-14,31,6.85l7.49-5.13c21-14.41,37.07-4.2,29.2,15.7,37.4-27.18,50.62,7.24,34,15.69l-82.76,52.29L218.5,331.32c-24.82,15.68-57.58,15.92-66.8,10.42-52.36-13.5-67.47-26.35-113.13-20.49m-22-93.2,54.13-22c13.81-5.61,29.28-4.17,35.1.14l29.33,21.73c40.7,30.16,44,22.63,91.95,25.49,10.62.63,17.61,17.74,0,24.51-44.76,20.46-72.38,11.28-113.18-9.6M180,42.71V61.46m0,81.79V162m0-147a87.36,87.36,0,1,1-87.35,87.36A87.35,87.35,0,0,1,180,15Zm27.18,56.24c-8.64-2.87-16.43-5.57-24.25-6.45-42.12-4.73-47.53,37.7-2.69,37.57,43.58-.14,39.48,42.34-2.75,37.56-7.81-.88-15.61-3.59-24.19-6.45"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic29"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-29</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M31.48,14.16H180V68.43c1.85,6,7.87,10.29,15,10.11,13.69-.34,14.26-18.15,38.69-18.15a36.69,36.69,0,0,1,0,73.38c-22.28,0-24.52-16.33-38.69-16-5.2.13-11.88,4.51-15,8.47V180H122.07c-2.36-3.22-4.2-7.18-4.28-10.53-.35-14.17,16-16.41,16-38.69a36.69,36.69,0,0,0-73.38,0c0,24.43,17.81,25,18.15,38.69A15.84,15.84,0,0,1,75,180H14.16V31.48A17.37,17.37,0,0,1,31.48,14.16Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,345.84H31.48a17.37,17.37,0,0,1-17.32-17.32V180"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M328.52,345.84H180V291.57c-1.85-6-7.87-10.29-15-10.11-13.69.34-14.26,18.15-38.69,18.15a36.69,36.69,0,1,1,0-73.38c22.28,0,24.52,16.33,38.69,16,5.2-.13,11.88-4.51,15-8.47V180h57.93c2.36,3.22,4.2,7.18,4.28,10.53.35,14.17-16,16.41-16,38.69a36.69,36.69,0,1,0,73.38,0c0-24.43-17.81-25-18.15-38.69A15.84,15.84,0,0,1,285,180h60.86V328.52a17.37,17.37,0,0,1-17.32,17.32Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M180,14.16H328.52a17.37,17.37,0,0,1,17.32,17.32V180"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic30"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-30</title>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="183.12" y1="88.55" x2="202.48" y2="41.85"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="164.71" y1="88.01" x2="160.96" y2="62.54"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="155.55" x2="180" y2="176.73"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="180" y1="269.08" x2="180" y2="290.26"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M210.69,187.77c-9.76-3.24-18.55-6.29-27.38-7.28-47.57-5.35-53.67,42.57-3,42.42,49.21-.16,44.58,47.81-3.11,42.41-8.82-1-17.62-4.06-27.31-7.28"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M206.38,86.16l.78-.5c5.68-10.76,23.57-30.61,28.77-46.58C252.88-13,160.69,34.51,107.71,23.67c-5.15-1.05,24.19,33,36.71,62.49"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M143.38,91.29H210c22.2,0,53.78,25.73,79.79,56.35,37.59,44.25,81.49,152.64,10.51,188.27-25,12.56-64,9.64-120.17,9.64-59.82,0-98.86,2.52-122.94-11C-7.7,298.2,30,189,67,144.63c24.31-29.12,54.18-53.34,76.38-53.34Z"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic31"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-31</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M233.87,99.33V326.12A12,12,0,0,1,222,338H25.88A12,12,0,0,1,14,326.12V33.88A11.89,11.89,0,0,1,25.88,22H156.55"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M233.87,99.33H168.42a11.89,11.89,0,0,1-11.86-11.86V22l77.31,77.31Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M275.91,61.67h42.36V281.46c0,43.82-42.36,43.83-42.36,0V61.67Z"/>
                                  <polyline fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" points="345.83 178.38 345.98 96.28 275.65 96.28"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="296.38" y1="337.98" x2="296.38" y2="314.31"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="61.44" y1="85.57" x2="123.95" y2="85.57"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="61.44" y1="144.73" x2="186.45" y2="144.73"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="61.44" y1="179.26" x2="186.45" y2="179.26"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="61.44" y1="213.79" x2="186.45" y2="213.79"/>
                                  <line fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" x1="61.44" y1="248.32" x2="123.95" y2="248.32"/>
                                </svg>
                              </div>
                            }
                            {el.binderPicktogram === "pic32"  &&
                              <div className="d--flex" style={{transform: "rotate(" + el.picktogramRotation + "deg)"}}>
                                <svg
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Picktogram')}
                                  width={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  height={(el.picktogramSize === '1' && '60') || (el.picktogramSize === '.5' && '50') || (el.picktogramSize === '.25' && '40') || (el.picktogramSize && '60')}
                                  id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
                                  <title>pic-svg-32</title>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M306.57,204.6,328.18,183C365.41,145.84,347,95.6,317,63.35A138.57,138.57,0,0,0,284.13,37c-15.24-8.54-63-21.05-94.25,9.36l-64.83,64.51c-17.5,17.42,26.66,34.27,49,12.24L190.39,107c24.13-21.88,54.45,22,92.24-7.86"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M54.2,194.39,32.63,172.85c-71.89-71.78,52.62-195,125.58-124l14.54,14.47"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M224.9,122.59l83.49,87.52c17,17.87-8.27,51.88-30.14,29.33l-39.13-40.35"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M205,226.28l43,44.19c17.23,17.69,52.09-8.46,30.23-31l-42-43.38"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M192,275.11l21.48,21.67c17.39,17.53,51.15-7.49,29.46-30.27"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M105.41,176.63l2.3,2.3a20.08,20.08,0,0,1,0,28.24L78,236.92a20.08,20.08,0,0,1-28.24,0l-2.29-2.3a20,20,0,0,1,0-28.24l29.73-29.75a20,20,0,0,1,28.24,0Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M155.43,190.24l2.29,2.3a20,20,0,0,1,0,28.24l-47.36,47.36a20.08,20.08,0,0,1-28.24,0l-2.3-2.29a20.06,20.06,0,0,1,0-28.24l47.36-47.37a20,20,0,0,1,28.25,0Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M174.78,234.5l2.3,2.29a20.05,20.05,0,0,1,0,28.25l-32.47,32.47a20,20,0,0,1-28.24,0l-2.3-2.29a20,20,0,0,1,0-28.24l32.47-32.47a20,20,0,0,1,28.24,0Z"/>
                                  <path fill="none" stroke={el.picktogramColor} strokeLinecap="round" strokeLinecap="round" strokeWidth="14px" d="M195.66,276.72,198,279a20.06,20.06,0,0,1,0,28.24L178,327.2a20.1,20.1,0,0,1-28.25,0l-2.29-2.3a20,20,0,0,1,0-28.24l19.94-19.94a20,20,0,0,1,28.24,0Z"/>
                                </svg>
                              </div>
                            }
                          </div>
                          }
                          {/* IMAGE */}
                          {el.Graphic &&
                            <div className="grid--vertical">
                              {el.transformImageVertical === '50' &&
                                <hr className="vertical--line"/>
                              }
                            </div>
                          }
                          {el.Graphic &&
                            <div className="grid--horizontal">
                              {el.transformImageHorizontal === '50' &&
                                <hr className="horizontal--line"/>
                              }
                            </div>
                          }
                          {el.image &&
                            [ el.imageRotation != 270 ?
                              <div
                              onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Graphic')}
                              className="elImage position--absolute" style={{
                                left:  el.transformImageHorizontal + '%',
                                top: el.transformImageVertical + '%',
                                transform: "translate(" + -el.transformImageHorizontal + "%," + -el.transformImageVertical + "%) rotate(" + el.imageRotation + "deg)",
                                width: el.imageSize + '%'
                              }}>
                              <div className="d--flex" style={{width: '100%'}}>
                              <img style={{width: '100%'}} src={el.image} alt="Graphics"/>
                              </div>
                              </div>
                              :
                              <div
                              onClick={() => this.handleToggleConfigSVGOptions(el.id, 'Graphic')}
                              className="elImage position--absolute" style={{
                                left:  el.transformImageHorizontal + '%',
                                top: el.transformImageVertical + '%',
                                transform: "translate(" + -50 + "%," + -50 + "%) rotate(" + el.imageRotation + "deg)",
                                width: el.imageSize + '%'
                              }}>
                              <div className="d--flex" style={{width: '100%'}}>
                              <img style={{width: '100%'}} src={el.image} alt="Graphics"/>
                              </div>
                              </div>
                            ]
                          }
                          {/* QR */}
                          {el.QrEan &&
                            <div>
                              {el.codeQrEan === "codeQR" &&
                                <div className="grid--vertical">
                                  {el.transformQrVertical === '50' &&
                                    <hr className="vertical--line"/>
                                  }
                                </div>
                              }
                              {el.codeQrEan  === "codeQR" &&
                                <div className="grid--horizontal">
                                  {el.transformQrHorizontal === '50' &&
                                    <hr className="horizontal--line"/>
                                  }
                                </div>
                              }
                            </div>
                          }
                          {el.codeQrEan === "codeQR" &&
                            <div>
                              {el.qrText &&
                                <div
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'QrEan')}
                                  className="elQr position--absolute" style={{left:  el.transformQrHorizontal + '%', top: el.transformQrVertical + "%",
                                  transform: "translate(" + -el.transformQrHorizontal + "%," + -el.transformQrVertical + "%)"
                                }}>
                                  {
                                    el.codeQrEan === "codeQR" &&
                                    <div className="d--grid" style={{transform: "rotate(" + el.qrRotation + "deg)"}}>
                                      {
                                        el.qrCodeType === "regularText" &&
                                        <QRCode
                                          value={el.qrText}
                                          size={el.qrSize}
                                          bgColor='#fff'
                                          fgColor="#000"
                                          level='L'
                                          renderAs='svg'
                                          />
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              {el.qrLink &&
                                <div
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'QrEan')}
                                  className="elQr position--absolute" style={{left:  el.transformQrHorizontal + '%', top: el.transformQrVertical + "%",
                                  transform: "translate(" + -el.transformQrHorizontal + "%," + -el.transformQrVertical + "%)"
                                }}>
                                  {
                                    el.codeQrEan === "codeQR" &&
                                    <div className="d--grid" style={{transform: "rotate(" + el.qrRotation + "deg)"}}>
                                      {
                                        el.qrCodeType === "link" &&
                                        <QRCode
                                          key={el.id}
                                          value={el.qrLink}
                                          size={el.qrSize}
                                          bgColor='#fff'
                                          fgColor="#000"
                                          level='L'
                                          renderAs='svg'
                                          />
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          {/* EAN */}
                          {el.QrEan &&
                            <div>
                              {el.codeQrEan === "codeEAN" &&
                                <div className="grid--vertical">
                                  {el.transformEanVertical === '50' &&
                                    <hr className="vertical--line"/>
                                  }
                                </div>
                              }
                              {el.codeQrEan === "codeEAN" &&
                                <div className="grid--horizontal">
                                  {el.transformEanHorizontal === '50' &&
                                    <hr className="horizontal--line"/>
                                  }
                                </div>
                              }
                            </div>
                          }
                          {el.codeQrEan === "codeEAN" &&
                            <div>
                              {el.eanText &&
                                <div
                                  onClick={() => this.handleToggleConfigSVGOptions(el.id, 'QrEan')}
                                  className={(el.eanSize === '1' && "elEan d--inlineFlex position--absolute") || (el.eanSize === '.9' && "elEan elEanThree d--inlineFlex position--absolute") ||  (el.eanSize === '.8' && "elEan elEanTwo d--inlineFlex position--absolute") || (el.eanSize  && "elEan d--inlineFlex position--absolute")}
                                  style={{left:  el.transformEanHorizontal + '%', top: el.transformEanVertical + '%', transform: "translate(" + -el.transformEanHorizontal + "%," + -el.transformEanVertical + "%)"}}>
                                  <div className="d--grid" style={{transform: "rotate(" + el.eanRotation + "deg)"}}>
                                    <Barcode
                                      key={el.id}
                                      value={el.eanText}
                                      />
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        </div>

                    </div>
                  </div>

                  {el.textOne &&
                  <div className="content content__textOne">
                    <div className="d--flexStretch container__textOne">
                      <div className="flex--auto textarea">
                        <p className="pb--2">{this.state.translations.insertText}:</p>
                        <textarea rows="5" placeholder={this.state.translations.typeText} id={el.id} name="textInputOne" onChange={this.handleLabelChange} value={el.textInputOne}></textarea>
                      </div>
                      <div className={!el.textInputOne ? "container--switch container--disabled" : "container--switch"}>
                        <div className="d--flex flex--auto text__options text__options--orientation">
                          <p>{this.state.translations.textOrientation}: </p>
                          <div className={el.fontRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                            <input type="radio" id={el.id} name="fontRotation" value='0' onChange={this.handleLabelChange}/>
                            <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                          </div>
                          <div className={el.fontRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                            <input type="radio" id={el.id} name="fontRotation" value='270' onChange={this.handleLabelChange}/>
                            <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                          </div>
                        </div>
                        <div className="d--flex flex--auto text__options text__options--font">
                          <img src={icoFont} alt="Wybierz font"/>
                          <div className="d--flex w--100">
                            <select id={el.id} name="fontStyle" className="select--fontStyle" onChange={this.handleLabelChange} value={el.fontStyle}>
                              <option value="NunitoSans">Nunito Sans</option>
                              <option value="OpenSans">Open Sans</option>
                              <option value="Roboto">Roboto</option>
                              <option value="RobotoSlab">Roboto Slab</option>
                              <option value="Lato">Lato</option>
                              <option value="Raleway">Raleway</option>
                              <option value="Playfair">Playfair</option>
                              <option value="PlayfairItalic">Playfair Italic</option>
                              <option value="Baloo">Baloo</option>
                              <option value="Merriweather">Merriweather</option>
                            </select>
                            <select id={el.id} name="fontWeight" className="select--fontWeight" onChange={this.handleLabelChange} value={el.fontWeight}>
                              <option value=
                              {(() => {
                                switch (el.fontStyle) {
                                  default: return "Normal";
                                  case "Playfair": return "500";
                                  case "PlayfairItalic": return "500";
                                  case "Baloo": return "500";
                                }
                              })()}
                              >{this.state.translations.normal}</option>
                              <option value="Bold">{this.state.translations.bold}</option>
                              <option value=
                              {(() => {
                                switch (el.fontStyle) {
                                  default: return "Lighter";
                                  case "Playfair": return "400";
                                  case "PlayfairItalic": return "400";
                                  case "Baloo": return "400";
                                }
                              })()}
                              >{this.state.translations.light}</option>
                            </select>
                          </div>
                        </div>
                        <div className="d--flex flex--auto text__options text__options--font">
                          <div className="d--flex mr--20 w--100">
                            <img src={icoFontSize} alt="Rozmiar"/>
                            <div className="input__number position--relative">
                              <input id={el.id} name="fontSize" min="1" type="number" onChange={this.handleLabelChange} value={el.fontSize}/>
                              <button id={el.id} name="fontSize" className="stepUp" onClick={this.stepUp}></button>
                              <button id={el.id} name="fontSize" className="stepDown" onClick={this.stepDown}></button>
                            </div>
                          </div>
                          <div className="d--flex mr--20 w--100">
                            <img src={icoFontInter} alt="Interlinia"/>
                            <div className="input__number position--relative">
                              <input id={el.id} name="fontLineHeight" min="1" type="number" onChange={this.handleLabelChange} value={el.fontLineHeight}/>
                              <button id={el.id} name="fontLineHeight" className="stepUp" onClick={this.stepUp}></button>
                              <button id={el.id} name="fontLineHeight" className="stepDown" onClick={this.stepDown}></button>
                            </div>
                          </div>
                          <div className="d--flex mr--20 w--100 position--relative">
                            <img src={icoColor} alt="Kolor"/>
                            <div className="textColorPicker" onClick={() => this.handleToggleColorPicker(el.id)}>
                              <span style={{backgroundColor: el.textOneColor}}></span>
                            </div>
                            <div className="textColor">
                              {el.colorPicker? <CompactPicker onChange={this.handleChangeItemColor(el.id)} /> : null}
                            </div>
                          </div>
                          <div className="d--flexBetween w--100">
                            <img src={icoRotation} alt="Obrót"/>
                            <input type="range" name="fontRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.fontRotation}/>
                          </div>
                        </div>
                        <div className="d--flexBetween flex--auto text__options text__options--font">
                          <div className="d--flexBetween w--100 mr--20">
                            <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                            <input type="range" name="transformHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformHorizontal}/>
                          </div>
                          <div className="d--flexBetween w--100">
                            <img src={icoVertical} alt="Przesuń w pionie"/>
                            <input type="range" name="transformVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformVertical}/>
                          </div>
                        </div>
                        {el.textInputOne &&
                        <div className="d--flexEnd">
                          <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionTextOne(el.id)}>X {this.state.translations.clean}</button>
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                  }
                  {el.textTwo &&
                  <div className="content content__textTwo">
                    <div className="d--flexStretch container__textTwo">
                      <div className="flex--auto textarea">
                        <p className="pb--2">{this.state.translations.insertText}:</p>
                        <textarea rows="5" placeholder={this.state.translations.typeText} id={el.id} name="textInputTwo" onChange={this.handleLabelChange} value={el.textInputTwo}></textarea>
                      </div>
                      <div className={!el.textInputTwo ? "container--switch container--disabled" : "container--switch"}>
                        <div className="d--flex flex--auto text__options text__options--orientation">
                          <p>{this.state.translations.textOrientation}: </p>
                          <div className={el.fontRotationTwo == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                            <input type="radio" id={el.id} name="fontRotationTwo" value="0" onChange={this.handleLabelChange}/>
                            <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                          </div>
                          <div className={el.fontRotationTwo == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                            <input type="radio" id={el.id} name="fontRotationTwo" value="270" onChange={this.handleLabelChange}/>
                            <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                          </div>
                        </div>
                        <div className="d--flex flex--auto text__options text__options--font">
                          <img src={icoFont} alt="Wybierz font"/>
                          <div className="d--flex w--100">
                            <select id={el.id} name="fontStyleTwo" className="select--fontStyle" onChange={this.handleLabelChange} value={el.fontStyleTwo}>
                              <option value="NunitoSans">Nunito Sans</option>
                              <option value="OpenSans">Open Sans</option>
                              <option value="Roboto">Roboto</option>
                              <option value="RobotoSlab">Roboto Slab</option>
                              <option value="Lato">Lato</option>
                              <option value="Raleway">Raleway</option>
                              <option value="Playfair">Playfair</option>
                              <option value="PlayfairItalic">Playfair Italic</option>
                              <option value="Baloo">Baloo</option>
                              <option value="Merriweather">Merriweather</option>
                            </select>
                            <select id={el.id} name="fontWeightTwo" className="select--fontWeight" onChange={this.handleLabelChange} value={el.fontWeightTwo}>
                            <option value=
                            {(() => {
                              switch (el.fontStyle) {
                                default: return "Normal";
                                case "Playfair": return "500";
                                case "PlayfairItalic": return "500";
                                case "Baloo": return "500";
                              }
                            })()}
                            >{this.state.translations.normal}</option>
                            <option value="Bold">{this.state.translations.bold}</option>
                            <option value=
                            {(() => {
                              switch (el.fontStyle) {
                                default: return "Lighter";
                                case "Playfair": return "400";
                                case "PlayfairItalic": return "400";
                                case "Baloo": return "400";
                              }
                            })()}
                            >{this.state.translations.light}</option>
                            </select>
                          </div>
                        </div>
                        <div className="d--flex flex--auto text__options text__options--font">
                          <div className="d--flex mr--20 w--100">
                            <img src={icoFontSize} alt="Rozmiar"/>
                              <div className="input__number position--relative">
                                <input id={el.id} name="fontSizeTwo" min="1" type="number" onChange={this.handleLabelChange} value={el.fontSizeTwo}/>
                                <button id={el.id} name="fontSizeTwo" className="stepUp" onClick={this.stepUp}></button>
                                <button id={el.id} name="fontSizeTwo" className="stepDown" onClick={this.stepDown}></button>
                              </div>
                          </div>
                          <div className="d--flex mr--20 w--100">
                            <img src={icoFontInter} alt="Interlinia"/>
                              <div className="input__number position--relative">
                                <input id={el.id} name="fontLineHeightTwo" min="1" type="number" onChange={this.handleLabelChange} value={el.fontLineHeightTwo}/>
                                <button id={el.id} name="fontLineHeightTwo" className="stepUp" onClick={this.stepUp}></button>
                                <button id={el.id} name="fontLineHeightTwo" className="stepDown" onClick={this.stepDown}></button>
                              </div>
                          </div>
                          <div className="d--flex mr--20 w--100 position--relative">
                            <img src={icoColor} alt="Kolor"/>
                            <div className="textColorPicker" onClick={() => this.handleToggleColorPicker(el.id)}>
                              <span style={{backgroundColor: el.textTwoColor}}></span>
                            </div>
                            <div className="textColor">
                              {el.colorPicker? <CompactPicker onChange={this.handleChangeItemTwoColor(el.id)} /> : null}
                            </div>
                          </div>
                          <div className="d--flexBetween w--100">
                            <img src={icoRotation} alt="Obrót"/>
                            <input type="range" name="fontRotationTwo" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.fontRotationTwo}/>
                          </div>
                        </div>
                        <div className="d--flexBetween flex--auto text__options text__options--font">
                          <div className="d--flexBetween w--100 mr--20">
                            <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                            <input type="range" name="transformHorizontalTwo" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformHorizontalTwo}/>
                          </div>
                          <div className="d--flexBetween w--100">
                            <img src={icoVertical} alt="Przesuń w pionie"/>
                            <input type="range" name="transformVerticalTwo" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformVerticalTwo}/>
                          </div>
                        </div>
                        {el.textInputTwo &&
                        <div className="d--flexEnd">
                          <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionTextTwo(el.id)}>X {this.state.translations.clean}</button>
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                  }
                  {el.Shape &&
                  <div className="content content__Shape">
                      <div className="d--flexStretch container__Shape">
                        <div className="flex--auto shapePicker">
                          <p className="pb--2">{this.state.translations.chooseForm}:</p>
                          <div className="d--flexStart">
                            <div className={el.binderShape === "shapeSquare" ? "shape__picker picker__shapeSquare shape__picker--active" : "shape__picker picker__shapeSquare"}>
                              <input id={el.id} className="shape__input shapeSquare" type="radio" name="binderShape" value="shapeSquare" onChange={this.handleLabelChange}/>
                            </div>
                            <div className={el.binderShape === "shapeRectangle" ? "shape__picker picker__shapeRectangle shape__picker--active" : "shape__picker picker__shapeRectangle"}>
                              <input id={el.id} className="shape__input shapeRectangle" type="radio" name="binderShape" value="shapeRectangle" onChange={this.handleLabelChange} />
                            </div>
                            <div className={el.binderShape === "shapeCircle" ? "shape__picker picker__shapeCircle shape__picker--active" : "shape__picker picker__shapeCircle"}>
                              <input id={el.id} className="shape__input shapeCircle" type="radio" name="binderShape" value="shapeCircle" onChange={this.handleLabelChange} />
                            </div>
                            <div className={el.binderShape === "shapeTriangle" ? "shape__picker picker__shapeTriangle shape__picker--active" : "shape__picker picker__shapeTriangle"}>
                              <input id={el.id} className="shape__input shapeTriangle" type="radio" name="binderShape" value="shapeTriangle" onChange={this.handleLabelChange} />
                            </div>
                            <div className={el.binderShape === "shapePentagon" ? "shape__picker picker__shapePentagon shape__picker--active" : "shape__picker picker__shapePentagon"}>
                              <input id={el.id} className="shape__input shapePentagon" type="radio" name="binderShape" value="shapePentagon" onChange={this.handleLabelChange} />
                            </div>
                            <div className={el.binderShape === "shapeHexagon" ? "shape__picker picker__shapeHexagon shape__picker--active" : "shape__picker picker__shapeHexagon"}>
                              <input id={el.id} className="shape__input shapeHexagon" type="radio" name="binderShape" value="shapeHexagon" onChange={this.handleLabelChange} />
                            </div>
                            <div className={el.binderShape === "shapeOctagon" ? "shape__picker picker__shapeOctagon shape__picker--active" : "shape__picker picker__shapeOctagon"}>
                              <input id={el.id} className="shape__input shapeOctagon" type="radio" name="binderShape" value="shapeOctagon" onChange={this.handleLabelChange} />
                            </div>
                          </div>
                        </div>
                        <div className={!el.binderShape ? "container--switch container--disabled" : "container--switch"}>
                          <div className="d--flex flex--auto text__options text__options--orientation">
                            <p>{this.state.translations.elOrientation}: </p>
                            <div className={el.shapeRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                              <input type="radio" id={el.id} name="shapeRotation" value='0' onChange={this.handleLabelChange}/>
                              <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                            </div>
                            <div className={el.shapeRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                              <input type="radio" id={el.id} name="shapeRotation" value='270' onChange={this.handleLabelChange}/>
                              <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                            </div>
                          </div>
                          <div className="d--flex flex--auto text__options text__options--font">
                            <img src={icoResize} alt="Zmień rozmiar"/>
                            <div className="d--flex w--100">
                              <select id={el.id} name="shapeSize" className="select--shapeSize" onChange={this.handleLabelChange} value={el.shapeSize}>
                                <option value="1">{this.state.translations.large}</option>
                                <option value=".5">{this.state.translations.medium}</option>
                                <option value=".25">{this.state.translations.small}</option>
                              </select>
                            </div>

                            <div className="d--flex ml--20 mr--20 w--100 position--relative">
                              <img src={icoColor} alt="Kolor"/>
                              <div className="textColorPicker" onClick={() => this.handleToggleColorPicker(el.id)}>
                                <span style={{backgroundColor: el.shapeColor}}></span>
                              </div>
                              <div className="textColor">
                                {el.colorPicker? <CompactPicker onChange={this.handleChangeShapeColor(el.id)} /> : null}
                              </div>
                            </div>
                            <div className="d--flexBetween w--100">
                              <img src={icoRotation} alt="Obrót"/>
                              <input type="range" name="shapeRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.shapeRotation} disabled={el.binderShape === "shapeCircle"}/>
                            </div>
                          </div>
                          <div className="d--flexBetween flex--auto text__options text__options--font">
                            <div className="d--flexBetween w--100 mr--20">
                              <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                              {el.shapeRotation == 270 ?
                              <input type="range" name="transformShapeHorizontal" id={el.id} step="1" min="-50" max="150" onChange={this.handleLabelChange} value={el.transformShapeHorizontal}/>
                              :
                              <input type="range" name="transformShapeHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformShapeHorizontal}/>
                              }
                            </div>
                            <div className="d--flexBetween w--100">
                              <img src={icoVertical} alt="Przesuń w pionie"/>
                              <input type="range" name="transformShapeVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformShapeVertical}/>
                            </div>
                          </div>
                          {el.binderShape &&
                          <div className="d--flexEnd">
                            <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionShape(el.id)}>X {this.state.translations.clean}</button>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {el.Picktogram &&
                  <div className="content content__Picktogram">
                      <div className="d--flexStretch container__Picktogram">
                        <div className="shapePicktogram">
                          <p className="pb--2">{this.state.translations.choosePictogram}:</p>
                          <div className="d--flexStart">
                            <div className="picktogramPreview">
                              {el.binderPicktogram &&
                                <div className="border">
                                  <img src={(() => {
                                    switch (el.binderPicktogram) {
                                      default: return null;
                                      case "pic1": return pic1;
                                      case "pic2": return pic2;
                                      case "pic3": return pic3;
                                      case "pic4": return pic4;
                                      case "pic5": return pic5;
                                      case "pic6": return pic6;
                                      case "pic7": return pic7;
                                      case "pic8": return pic8;
                                      case "pic9": return pic9;
                                      case "pic10": return pic10;
                                      case "pic11": return pic11;
                                      case "pic12": return pic12;
                                      case "pic13": return pic13;
                                      case "pic14": return pic14;
                                      case "pic15": return pic15;
                                      case "pic16": return pic16;
                                      case "pic17": return pic17;
                                      case "pic18": return pic18;
                                      case "pic19": return pic19;
                                      case "pic20": return pic20;
                                      case "pic21": return pic21;
                                      case "pic22": return pic22;
                                      case "pic23": return pic23;
                                      case "pic24": return pic24;
                                      case "pic25": return pic25;
                                      case "pic26": return pic26;
                                      case "pic27": return pic27;
                                      case "pic28": return pic28;
                                      case "pic29": return pic29;
                                      case "pic30": return pic30;
                                      case "pic31": return pic31;
                                      case "pic32": return pic32;
                                    }
                                  })()}
                                  alt="Podgląd"/>
                                </div>
                              }
                            </div>

                            <div className="d--flexStart picktogramPicker">
                              <div className={el.binderPicktogram === "pic1" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic1" onChange={this.handleLabelChange}/>
                                <img src={pic1} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic2" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic2" onChange={this.handleLabelChange}/>
                                <img src={pic2} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic3" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic3" onChange={this.handleLabelChange}/>
                                <img src={pic3} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic4" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic4" onChange={this.handleLabelChange}/>
                                <img src={pic4} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic5" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic5" onChange={this.handleLabelChange}/>
                                <img src={pic5} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic6" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic6" onChange={this.handleLabelChange}/>
                                <img src={pic6} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic7" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic7" onChange={this.handleLabelChange}/>
                                <img src={pic7} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic8" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic8" onChange={this.handleLabelChange}/>
                                <img src={pic8} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic9" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic9" onChange={this.handleLabelChange}/>
                                <img src={pic9} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic10" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic10" onChange={this.handleLabelChange}/>
                                <img src={pic10} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic11" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic11" onChange={this.handleLabelChange}/>
                                <img src={pic11} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic12" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic12" onChange={this.handleLabelChange}/>
                                <img src={pic12} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic13" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic13" onChange={this.handleLabelChange}/>
                                <img src={pic13} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic14" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic14" onChange={this.handleLabelChange}/>
                                <img src={pic14} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic15" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic15" onChange={this.handleLabelChange}/>
                                <img src={pic15} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic16" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic16" onChange={this.handleLabelChange}/>
                                <img src={pic16} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic17" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic17" onChange={this.handleLabelChange}/>
                                <img src={pic17} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic18" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic18" onChange={this.handleLabelChange}/>
                                <img src={pic18} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic19" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic19" onChange={this.handleLabelChange}/>
                                <img src={pic19} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic20" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic20" onChange={this.handleLabelChange}/>
                                <img src={pic20} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic21" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic21" onChange={this.handleLabelChange}/>
                                <img src={pic21} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic22" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic22" onChange={this.handleLabelChange}/>
                                <img src={pic22} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic23" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic23" onChange={this.handleLabelChange}/>
                                <img src={pic23} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic24" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic24" onChange={this.handleLabelChange}/>
                                <img src={pic24} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic25" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic25" onChange={this.handleLabelChange}/>
                                <img src={pic25} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic26" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic26" onChange={this.handleLabelChange}/>
                                <img src={pic26} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic27" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic27" onChange={this.handleLabelChange}/>
                                <img src={pic27} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic28" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic28" onChange={this.handleLabelChange}/>
                                <img src={pic28} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic29" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic29" onChange={this.handleLabelChange}/>
                                <img src={pic29} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic30" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic30" onChange={this.handleLabelChange}/>
                                <img src={pic30} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic31" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic31" onChange={this.handleLabelChange}/>
                                <img src={pic31} alt="Moxom" />
                              </div>
                              <div className={el.binderPicktogram === "pic32" ? "picktogram__picker picktogram__picker--active" : "picktogram__picker"}>
                                <input id={el.id} className="picktogram__input" type="radio" name="binderPicktogram" value="pic32" onChange={this.handleLabelChange}/>
                                <img src={pic32} alt="Moxom" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={!el.binderPicktogram ? "container--switch container--disabled" : "container--switch"}>
                          <div className="d--flex flex--auto text__options text__options--orientation">
                            <p>{this.state.translations.elOrientation}: </p>
                            <div className={el.picktogramRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                              <input type="radio" id={el.id} name="picktogramRotation" value='0' onChange={this.handleLabelChange}/>
                              <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                            </div>
                            <div className={el.picktogramRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                              <input type="radio" id={el.id} name="picktogramRotation" value='270' onChange={this.handleLabelChange}/>
                              <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                            </div>
                          </div>
                          <div className="d--flex flex--auto text__options text__options--font">
                            <img src={icoResize} alt="Zmień rozmiar"/>
                            <div className="d--flex w--100">
                              <select id={el.id} name="picktogramSize" className="select--picktogramSize" onChange={this.handleLabelChange} value={el.picktogramSize}>
                                <option value="1">{this.state.translations.large}</option>
                                <option value=".5">{this.state.translations.medium}</option>
                                <option value=".25">{this.state.translations.small}</option>
                              </select>
                            </div>
                            <div className="d--flex ml--20 mr--20 w--100 position--relative">
                              <img src={icoColor} alt="Kolor"/>
                              <div className="textColorPicker" onClick={() => this.handleToggleColorPicker(el.id)}>
                                <span style={{backgroundColor: el.picktogramColor}}></span>
                              </div>
                              <div className="textColor">
                                {el.colorPicker? <CompactPicker onChange={this.handleChangePicktogramColor(el.id)} /> : null}
                              </div>
                            </div>
                            <div className="d--flexBetween w--100">
                              <img src={icoRotation} alt="Obrót"/>
                              <input type="range" name="picktogramRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.picktogramRotation}/>
                            </div>
                          </div>
                          <div className="d--flexBetween flex--auto text__options text__options--font">
                            <div className="d--flexBetween w--100 mr--20">
                              <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                              <input type="range" name="transformPicktogramHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformPicktogramHorizontal}/>
                            </div>
                            <div className="d--flexBetween w--100">
                              <img src={icoVertical} alt="Przesuń w pionie"/>
                              <input type="range" name="transformPicktogramVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformPicktogamVertical}/>
                            </div>
                          </div>
                          {el.binderPicktogram &&
                          <div className="d--flexEnd">
                            <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionPicktogram(el.id)}>X {this.state.translations.clean}</button>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {el.Graphic &&
                  <div className="content content__Picktogram">
                      <div className="d--flexStretch container__Picktogram">
                        <div className="flex--auto shapePicktogram">
                          <p className="pb--2">{this.state.translations.chooseGraphic}:</p>
                          <div className="d--flexStart">
                            <div>
                              <FileUpload key={el.id} parentCallback={this.callback(el.id)} id={el.id+'-uploadFile'}/>
                            </div>
                          </div>
                        </div>
                        <div className={!el.image ? "container--switch container--disabled" : "container--switch"}>
                          <div className="d--flex flex--auto text__options text__options--orientation">
                            <p>{this.state.translations.elOrientation}: </p>
                            <div className={el.imageRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                              <input type="radio" id={el.id} name="imageRotation" value='0' onChange={this.handleLabelChange}/>
                              <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                            </div>
                            <div className={el.imageRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                              <input type="radio" id={el.id} name="imageRotation" value='270' onChange={this.handleLabelChange}/>
                              <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                            </div>
                          </div>
                          <div className="d--flex flex--auto text__options text__options--font">
                            <div className="option--first">
                              <img src={icoResize} alt="Zmień rozmiar"/>
                            </div>
                            <div className="d--flex w--100">
                              <input type="range" name="imageSize" id={el.id} step="1" min="10" max="100" onChange={this.handleLabelChange} value={el.imageSize}/>
                            </div>
                            <div className="d--flexBetween ml--20 w--100">
                              <img src={icoRotation} alt="Obrót"/>
                              <input type="range" name="imageRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.imageRotation}/>
                            </div>
                          </div>
                          <div className="d--flexBetween flex--auto text__options text__options--font">
                            <div className="d--flexBetween w--100 mr--20">
                              <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                              {el.imageRotation == 270 ?
                              <input type="range" name="transformImageHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformImageHorizontal}/>
                              :
                              <input type="range" name="transformImageHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformImageHorizontal}/>
                              }
                            </div>
                            <div className="d--flexBetween w--100">
                              <img src={icoVertical} alt="Przesuń w pionie"/>
                              {el.imageRotation == 270 ?
                                <input type="range" name="transformImageVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transforImageVertical}/>
                                :
                                <input type="range" name="transformImageVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transforImageVertical}/>
                              }
                            </div>
                          </div>
                          {el.image &&
                          <div className="d--flexEnd">
                            <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionImage(el.id)}>X {this.state.translations.clean}</button>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {el.QrEan &&
                  <div>
                       <div className="content content__QrEan">
                         <div className="d--flexStretch container__QrEan">
                           <div className="flex--auto shapePicktogram">
                             <p className="pb--2">{this.state.translations.generateQrEan}</p>
                             <div className="d--flex mr--20 pb--2">
                               <div className="d--flexStart w--100">
                                 <select id={el.id} name="codeQrEan" className="select--QrEan ml--0" onChange={this.handleLabelChange} value={el.codeQrEan}>
                                   <option value="codeQR">{this.state.translations.qrCode}</option>
                                   <option value="codeEAN">{this.state.translations.eanCode}</option>
                                 </select>
                               </div>
                               <div className="d--flexStart w--100">
                               {el.codeQrEan === 'codeQR' &&
                                 <select id={el.id} name="qrCodeType" className="code--type" onChange={this.handleLabelChange} value={el.qrCodeType}>
                                   <option value="regularText">{this.state.translations.text}</option>
                                   <option value="link">Link</option>
                                 </select>
                               }
                               </div>
                             </div>
                             {el.codeQrEan === "codeQR" &&
                               <div>
                                 {el.qrCodeType === 'regularText' &&
                                   <div className="mr--20">
                                     <textarea maxLength="50" rows="5" placeholder={this.state.translations.maxSeven} id={el.id} name="qrText" onChange={this.handleLabelChange} value={el.qrText}/>
                                   </div>
                                 }
                               </div>
                             }
                             {el.codeQrEan === "codeQR" &&
                               <div>
                                 {el.qrCodeType === 'link' &&
                                   <div className="mr--20">
                                     <input type="text" maxLength="50" placeholder={this.state.translations.maxSeven} id={el.id} name="qrLink" onChange={this.handleLabelChange} value={el.qrLink}/>
                                   </div>
                                 }
                               </div>
                             }
                             {el.codeQrEan === 'codeEAN' &&
                               <div className="mr--20">
                                 <input type="text" maxLength="20" placeholder={this.state.translations.maxTwo} id={el.id} name="eanText" onChange={this.handleLabelChange} value={el.eanText}/>
                               </div>
                             }
                           </div>

                           {el.codeQrEan === "codeQR" &&
                             <div>
                               {el.qrCodeType === 'regularText' &&
                                 <div className={!el.qrText ? "container--switch container--disabled" : "container--switch"}>
                                   <div className="d--flex flex--auto text__options text__options--orientation">
                                     <p>{this.state.translations.elOrientation}: </p>
                                     <div className={el.qrRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                                       <input type="radio" id={el.id} name="qrRotation" value='0' onChange={this.handleLabelChange}/>
                                       <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                                     </div>
                                     <div className={el.qrRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                                       <input type="radio" id={el.id} name="qrRotation" value='270' onChange={this.handleLabelChange}/>
                                       <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                                     </div>
                                   </div>
                                   <div className="d--flex flex--auto text__options text__options--font">
                                     <div className="option--first">
                                       <img src={icoResize} alt="Zmień rozmiar"/>
                                     </div>
                                     <div className="d--flex w--100">
                                       <select id={el.id} name="qrSize" className="select--imageSize" onChange={this.handleLabelChange} value={el.qrSize}>
                                         <option value="90">{this.state.translations.large}</option>
                                         <option value="70">{this.state.translations.medium}</option>
                                         <option value="50">{this.state.translations.small}</option>
                                       </select>
                                     </div>
                                     <div className="d--flexBetween ml--20 w--100">
                                       <img src={icoRotation} alt="Obrót"/>
                                       <input type="range" name="qrRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.qrRotation}/>
                                     </div>
                                   </div>
                                   <div className="d--flexBetween flex--auto text__options text__options--font">
                                     <div className="d--flexBetween w--100 mr--20">
                                       <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                                       <input type="range" name="transformQrHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformQrHorizontal}/>
                                     </div>
                                     <div className="d--flexBetween w--100">
                                       <img src={icoVertical} alt="Przesuń w pionie"/>
                                       <input type="range" name="transformQrVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformQrVertical}/>
                                     </div>
                                   </div>
                                   {el.qrText &&
                                     <div className="d--flexEnd">
                                       <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionQrText(el.id)}>X {this.state.translations.clean}</button>
                                     </div>
                                   }
                                 </div>
                               }
                               {el.qrCodeType === 'link' &&
                                 <div className={!el.qrLink ? "container--switch container--disabled" : "container--switch"}>
                                   <div className="d--flex flex--auto text__options text__options--orientation">
                                     <p>{this.state.translations.elOrientation}: </p>
                                     <div className={el.qrRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                                       <input type="radio" id={el.id} name="qrRotation" value='0' onChange={this.handleLabelChange}/>
                                       <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                                     </div>
                                     <div className={el.qrRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                                       <input type="radio" id={el.id} name="qrRotation" value='270' onChange={this.handleLabelChange}/>
                                       <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                                     </div>
                                   </div>
                                   <div className="d--flex flex--auto text__options text__options--font">
                                     <div className="option--first">
                                       <img src={icoResize} alt="Zmień rozmiar"/>
                                     </div>
                                     <div className="d--flex w--100">
                                       <select id={el.id} name="qrSize" className="select--imageSize" onChange={this.handleLabelChange} value={el.qrSize}>
                                         <option value="90">{this.state.translations.large}</option>
                                         <option value="70">{this.state.translations.medium}</option>
                                         <option value="50">{this.state.translations.small}</option>
                                       </select>
                                     </div>
                                     <div className="d--flexBetween ml--20 w--100">
                                       <img src={icoRotation} alt="Obrót"/>
                                       <input type="range" name="qrRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.qrRotation}/>
                                     </div>
                                   </div>
                                   <div className="d--flexBetween flex--auto text__options text__options--font">
                                     <div className="d--flexBetween w--100 mr--20">
                                       <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                                       <input type="range" name="transformQrHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformQrHorizontal}/>
                                     </div>
                                     <div className="d--flexBetween w--100">
                                       <img src={icoVertical} alt="Przesuń w pionie"/>
                                       <input type="range" name="transformQrVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformQrVertical}/>
                                     </div>
                                   </div>
                                   {el.qrLink &&
                                     <div className="d--flexEnd">
                                       <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionQrLink(el.id)}>X {this.state.translations.clean}</button>
                                     </div>
                                   }
                                 </div>
                               }
                             </div>
                           }

                           {el.codeQrEan === "codeEAN" &&
                             <div className={!el.eanText ? "container--switch container--disabled" : "container--switch"}>
                               <div className="d--flex flex--auto text__options text__options--orientation">
                                 <p>{this.state.translations.elOrientation}: </p>
                                 <div className={el.eanRotation == 0 ? "radio radio--checked d--flex" : "radio d--flex"}>
                                   <input type="radio" id={el.id} name="eanRotation" value='0' onChange={this.handleLabelChange}/>
                                   <label><p><strong>{this.state.translations.horizontal}</strong></p></label>
                                 </div>
                                 <div className={el.eanRotation == 270 ? "radio radio--checked d--flex" : "radio d--flex"}>
                                   <input type="radio" id={el.id} name="eanRotation" value='270' onChange={this.handleLabelChange}/>
                                   <label><p><strong>{this.state.translations.vertical}</strong></p></label>
                                 </div>
                               </div>
                               <div className="d--flex flex--auto text__options text__options--font">
                                 <div className="option--first">
                                   <img src={icoResize} alt="Zmień rozmiar"/>
                                 </div>
                                 <div className="d--flex w--100">
                                   <select id={el.id} name="eanSize" className="select--imageSize" onChange={this.handleLabelChange} value={el.eanSize}>
                                     <option value="1">{this.state.translations.large}</option>
                                     <option value=".9">{this.state.translations.medium}</option>
                                     <option value=".8">{this.state.translations.small}</option>
                                   </select>
                                 </div>
                                 <div className="d--flexBetween ml--20 w--100">
                                   <img src={icoRotation} alt="Obrót"/>
                                   <input type="range" name="eanRotation" id={el.id} step="15" min="0" max="360" onChange={this.handleLabelChange} value={el.eanRotation}/>
                                 </div>

                               </div>
                               <div className="d--flexBetween flex--auto text__options text__options--font">
                                 <div className="d--flexBetween w--100 mr--20">
                                   <img src={icoHorizontal} alt="Przesuń w poziomie"/>
                                   <input type="range" name="transformEanHorizontal" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformEanHorizontal}/>
                                 </div>
                                 <div className="d--flexBetween w--100">
                                   <img src={icoVertical} alt="Przesuń w pionie"/>
                                   <input type="range" name="transformEanVertical" id={el.id} step="1" min="0" max="100" onChange={this.handleLabelChange} value={el.transformEanVertical}/>
                                 </div>
                               </div>
                               {el.eanText &&
                                 <div className="d--flexEnd">
                                   <button className="clearLabelOption" onClick={() => this.handleClearLabelOptionEan(el.id)}>X {this.state.translations.clean}</button>
                                 </div>
                               }
                             </div>
                           }

                         </div>
                       </div>
                    </div>
                  }

                </div>
              }
            </div>
            ))}
            <div className="container__info container__info--red">
              <p className="p--xl color--blackSecond">{this.state.translations.alertHead}</p>
              <p className="color--grayFourth">{ ReactHtmlParser (this.state.translations.alert) }</p>
                <div className={this.state.agree ? "checkbox d--flexStart": "checkbox checkbox--checked d--flexStart"}>
                  <input type="checkbox" id="agree" name="alertAgree" value='0' onChange={this.handleAgree}/>
                  <label htmlFor="agree"><p className="p--sm"><strong>{this.state.translations.alertOk}</strong></p></label>
                </div>
            </div>
          </div>

          <div className="d--flexBetween container__buttons">
            <Link to="/">
              <p className="p--sm color--grayFourth d--flex"><img className="mr--10" src={icoBack} alt={this.state.translations.returnBtn}/><strong>{this.state.translations.returnBtn}</strong></p>
            </Link>
            <div className="d--flexBetween">
              {/*<SettingsUpload key="uploadSettings" parentCallback={this.callback()} id="uploadSettings"/>*/}
              {/*<button className='btn--secondary mr--20' onClick={this.exportFile}><img className="mr--10" src={icoExport} alt={this.state.translations.returnBtn}/> Exportuj</button>*/}
              <button className='btn--secondary mr--20' onClick={this.handleTest}><img className="mr--10" src={icoPrintTest} alt={this.state.translations.returnBtn}/>{this.state.translations.prinTest}</button>
              {this.state.agree ?
                  <button className='btn--primary btn--disabled' disabled>{this.state.translations.highlightInfo}</button>
                :
                  <Link to={{
                      pathname: '/preview',
                      state: this.state,
                    }}
                    onClick={this.handleLocal}
                    target='_blank'
                    >
                    <button className='btn--primary'>{this.state.translations.generatePreview}</button>
                  </Link>
              }
            </div>
          </div>

          <Footer/>
      </div>
    )
  }
}

export default Configurator;

